window.setupNewRelic = function(accountId, licenseKey, applicationId) {
    window.NREUM || (NREUM = {});
    NREUM.init = {
        privacy: {
            cookies_enabled: true
        },
        ajax: {
            deny_list: [
                "bam.nr-data.net"
            ],
            capture_payloads: "none"
        },
        jserrors: {
            enabled: false
        },
        logging: {
            enabled: false
        },
        session_replay: {
            enabled: false
        },
        session_trace: {
            enabled: false
        },
        obfuscate: [
            {
                regex: /^(?!https?:\/\/)[\s\S]+$/,
                replacement: "[redacted]",
                eventFilter: [
                    "BrowserInteraction"
                ]
            }
        ]
    };
    NREUM.loader_config = {
        accountID: accountId,
        trustKey: accountId,
        agentID: applicationId,
        licenseKey: licenseKey,
        applicationID: applicationId
    };
    NREUM.info = {
        beacon: "bam.nr-data.net",
        errorBeacon: "bam.nr-data.net",
        licenseKey: licenseKey,
        applicationID: applicationId,
        sa: 1
    };
    (()=>{
        var e1 = {
            8122 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    a: ()=>i
                });
                var n = r(944);
                function i(e1, t1) {
                    try {
                        if (!e1 || "object" != typeof e1) return (0, n.R)(3);
                        if (!t1 || "object" != typeof t1) return (0, n.R)(4);
                        const r = Object.create(Object.getPrototypeOf(t1), Object.getOwnPropertyDescriptors(t1)), s = 0 === Object.keys(r).length ? e1 : r;
                        for(let a in s)if (void 0 !== e1[a]) try {
                            if (null === e1[a]) {
                                r[a] = null;
                                continue;
                            }
                            Array.isArray(e1[a]) && Array.isArray(t1[a]) ? r[a] = Array.from(new Set([
                                ...e1[a],
                                ...t1[a]
                            ])) : e1[a] instanceof Map || e1[a] instanceof Set || e1[a] instanceof Date || e1[a] instanceof RegExp ? r[a] = e1[a] : "object" == typeof e1[a] && null !== t1[a] && "object" == typeof t1[a] ? r[a] = i(e1[a], t1[a]) : r[a] = e1[a];
                        } catch (e1) {
                            r[a] || (0, n.R)(1, e1);
                        }
                        return r;
                    } catch (e1) {
                        (0, n.R)(2, e1);
                    }
                }
            },
            2555 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    f: ()=>a
                });
                var n = r(384), i = r(8122);
                const s = {
                    beacon: n.NT.beacon,
                    errorBeacon: n.NT.errorBeacon,
                    licenseKey: void 0,
                    applicationID: void 0,
                    sa: void 0,
                    queueTime: void 0,
                    applicationTime: void 0,
                    ttGuid: void 0,
                    user: void 0,
                    account: void 0,
                    product: void 0,
                    extra: void 0,
                    jsAttributes: {},
                    userAttributes: void 0,
                    atts: void 0,
                    transactionName: void 0,
                    tNamePlain: void 0
                };
                function a(e1) {
                    try {
                        return !!e1.licenseKey && !!e1.errorBeacon && !!e1.applicationID;
                    } catch (e1) {
                        return !1;
                    }
                }
                r.d(t1, [
                    "D",
                    0,
                    (e1)=>(0, i.a)(e1, s)
                ]);
            },
            7699 (e1, t1, r) {
                "use strict";
                var n = r(860);
                const i = {
                    [n.K7.logging]: !0,
                    [n.K7.genericEvents]: !0,
                    [n.K7.jserrors]: !0,
                    [n.K7.ajax]: !0
                };
                r.d(t1, [
                    "It",
                    0,
                    1e6,
                    "KC",
                    0,
                    i,
                    "qh",
                    0,
                    "SESSION_ERROR"
                ]);
            },
            9324 (e1, t1, r) {
                "use strict";
                r.d(t1, [
                    "A",
                    0,
                    "@newrelic/rrweb",
                    "x",
                    0,
                    "1.323.0"
                ]);
            },
            981 (e1, t1, r) {
                "use strict";
                r.d(t1, [
                    "R",
                    0,
                    {
                        AJAX: "AjaxRequest",
                        PA: "PageAction",
                        UA: "UserAction",
                        BP: "BrowserPerformance",
                        WS: "WebSocket",
                        SPV: "SecurityPolicyViolation",
                        JSE: "JavaScriptError",
                        LOG: "Log",
                        PVE: "PageView",
                        PVT: "PageViewTiming",
                        SR: "SessionReplay",
                        ST: "SessionTrace",
                        BI: "BrowserInteraction"
                    }
                ]);
            },
            9752 (e1, t1, r) {
                "use strict";
                const n = "newrelic-iframe-", i = n + "timing-update", s = n + "api", a = n + "api-response", o = n + "vitals-update", c = n + "ajax";
                r.d(t1, [
                    "$8",
                    0,
                    o,
                    "Gi",
                    0,
                    a,
                    "KU",
                    0,
                    c,
                    "Pl",
                    0,
                    n,
                    "cS",
                    0,
                    s,
                    "cr",
                    0,
                    i
                ]);
            },
            6154 (e1, t1, r) {
                "use strict";
                var n = r(1863);
                const i = "undefined" != typeof window && !!window.document, s = "undefined" != typeof WorkerGlobalScope && ("undefined" != typeof self && self instanceof WorkerGlobalScope && self.navigator instanceof WorkerNavigator || "undefined" != typeof globalThis && globalThis instanceof WorkerGlobalScope && globalThis.navigator instanceof WorkerNavigator), a = i ? window : "undefined" != typeof WorkerGlobalScope && ("undefined" != typeof self && self instanceof WorkerGlobalScope && self || "undefined" != typeof globalThis && globalThis instanceof WorkerGlobalScope && globalThis), o = Boolean("hidden" === a?.document?.visibilityState), c = "" + a?.location, d = /iPad|iPhone|iPod/.test(a.navigator?.userAgent), u = d && "undefined" == typeof SharedWorker, l = (()=>{
                    const e1 = a.navigator?.userAgent?.match(/Firefox[/\s](\d+\.\d+)/);
                    return Array.isArray(e1) && e1.length >= 2 ? +e1[1] : 0;
                })(), f = Date.now() - (0, n.t)();
                r.d(t1, [
                    "OF",
                    0,
                    d,
                    "RI",
                    0,
                    i,
                    "WN",
                    0,
                    f,
                    "bv",
                    0,
                    s,
                    "gm",
                    0,
                    a,
                    "lR",
                    0,
                    l,
                    "m",
                    0,
                    c,
                    "mw",
                    0,
                    o,
                    "sb",
                    0,
                    u,
                    "zk",
                    0,
                    ()=>{
                        const e1 = a?.performance?.getEntriesByType?.("navigation")?.[0];
                        if (e1 && e1.responseStart > 0 && e1.responseStart < a.performance.now()) return e1;
                    }
                ]);
            },
            7295 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    Xv: ()=>a,
                    gX: ()=>i,
                    iW: ()=>s
                });
                var n = [];
                function i(e1) {
                    if (!e1 || s(e1)) return !1;
                    if (0 === n.length) return !0;
                    if ("*" === n[0].hostname) return !1;
                    for(var t1 = 0; t1 < n.length; t1++){
                        var r = n[t1];
                        if (r.hostname.test(e1.hostname) && r.pathname.test(e1.pathname)) return !1;
                    }
                    return !0;
                }
                function s(e1) {
                    return void 0 === e1.hostname;
                }
                function a(e1) {
                    if (n = [], e1 && e1.length) for(var t1 = 0; t1 < e1.length; t1++){
                        let r = e1[t1];
                        if (!r) continue;
                        if ("*" === r) return void (n = [
                            {
                                hostname: "*"
                            }
                        ]);
                        0 === r.indexOf("http://") ? r = r.substring(7) : 0 === r.indexOf("https://") && (r = r.substring(8));
                        const i = r.indexOf("/");
                        let s, a;
                        i > 0 ? (s = r.substring(0, i), a = r.substring(i)) : (s = r, a = "*");
                        let [c] = s.split(":");
                        n.push({
                            hostname: o(c),
                            pathname: o(a, !0)
                        });
                    }
                }
                function o(e1, t1 = !1) {
                    const r = e1.replace(/[.+?^${}()|[\]\\]/g, (e1)=>"\\" + e1).replace(/\*/g, ".*?");
                    return new RegExp((t1 ? "^" : "") + r + "$");
                }
            },
            3241 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    W: ()=>i
                });
                var n = r(6154);
                function i(e1 = {}) {
                    try {
                        n.gm.dispatchEvent(new CustomEvent("newrelic", {
                            detail: e1
                        }));
                    } catch (e1) {}
                }
            },
            1687 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    Ak: ()=>o,
                    Ze: ()=>d,
                    x3: ()=>c
                });
                var n = r(3241), i = r(3606), s = r(860), a = r(2646);
                function o(e1, t1) {
                    if (!e1) return;
                    const r = {
                        staged: !1,
                        priority: s.P3[t1] || 0
                    };
                    e1.runtime.drainRegistry.get(t1) || e1.runtime.drainRegistry.set(t1, r);
                }
                function c(e1, t1) {
                    if (!e1) return;
                    const r = e1.runtime.drainRegistry;
                    r && (r.get(t1) && r.delete(t1), l(e1, t1, !1), r.size && u(e1));
                }
                function d(e1, t1 = "feature", r = !1) {
                    if (e1) {
                        if (!e1.runtime.drainRegistry.get(t1) || r) return l(e1, t1);
                        e1.runtime.drainRegistry.get(t1).staged = !0, u(e1);
                    }
                }
                function u(e1) {
                    if (!e1) return;
                    const t1 = Array.from(e1.runtime.drainRegistry);
                    t1.every(([e1, t1])=>t1.staged) && (t1.sort((e1, t1)=>e1[1].priority - t1[1].priority), t1.forEach(([t1])=>{
                        e1.runtime.drainRegistry.delete(t1), l(e1, t1);
                    }));
                }
                function l(e1, t1, r = !0) {
                    if (!e1) return;
                    const s = e1.ee, o = i.i.handlers;
                    if (s && !s.aborted && s.backlog && o) {
                        if ((0, n.W)({
                            type: "lifecycle",
                            name: "drain",
                            feature: t1
                        }), r) {
                            const e1 = s.backlog[t1], r = o[t1];
                            if (r) {
                                for(let t1 = 0; e1 && t1 < e1.length; ++t1)f(e1[t1], r);
                                Object.entries(r).forEach(([e1, t1])=>{
                                    Object.values(t1 || {}).forEach((t1)=>{
                                        t1[0]?.on && t1[0].context() instanceof a.y && !t1[0].listeners(e1).includes(t1[1]) && t1[0].on(e1, t1[1]);
                                    });
                                });
                            }
                        }
                        s.isolatedBacklog || delete o[t1], s.backlog[t1] = null, s.emit("drain-" + t1, []);
                    }
                }
                function f(e1, t1) {
                    var r = e1[1];
                    Object.values(t1[r] || {}).forEach((t1)=>{
                        var r = e1[0];
                        if (t1[0] === r) {
                            var n = t1[1], i = e1[3], s = e1[2];
                            n.apply(i, s);
                        }
                    });
                }
            },
            7836 (e1, t1, r) {
                "use strict";
                var n = r(384), i = r(8990), s = r(2646), a = r(5607);
                const o = "nr@context:".concat(a.W), c = function e1(t1, r) {
                    var n = {}, a = {}, u = {}, l = !1;
                    try {
                        l = 16 === r.length && d.initializedAgents?.[r]?.runtime.isolatedBacklog;
                    } catch (e1) {}
                    var f = {
                        on: p,
                        addEventListener: p,
                        removeEventListener: function(e1, t1) {
                            var r = n[e1];
                            if (!r) return;
                            for(var i = 0; i < r.length; i++)r[i] === t1 && r.splice(i, 1);
                        },
                        emit: function(e1, r, n, i, s) {
                            !1 !== s && (s = !0);
                            if (c.aborted && !i) return;
                            t1 && s && t1.emit(e1, r, n);
                            var o = h(n);
                            g(e1).forEach((e1)=>{
                                e1.apply(o, r);
                            });
                            var d = v()[a[e1]];
                            d && d.push([
                                f,
                                e1,
                                r,
                                o
                            ]);
                            return o;
                        },
                        get: m,
                        listeners: g,
                        context: h,
                        buffer: function(e1, t1) {
                            const r = v();
                            if (t1 = t1 || "feature", f.aborted) return;
                            Object.entries(e1 || {}).forEach(([e1, n])=>{
                                a[n] = t1, t1 in r || (r[t1] = []);
                            });
                        },
                        abort: function() {
                            f._aborted = !0, Object.keys(f.backlog).forEach((e1)=>{
                                delete f.backlog[e1];
                            });
                        },
                        isBuffering: function(e1) {
                            return !!v()[a[e1]];
                        },
                        debugId: r,
                        backlog: l ? {} : t1 && "object" == typeof t1.backlog ? t1.backlog : {},
                        isolatedBacklog: l
                    };
                    return Object.defineProperty(f, "aborted", {
                        get: ()=>{
                            let e1 = f._aborted || !1;
                            return e1 || (t1 && (e1 = t1.aborted), e1);
                        }
                    }), f;
                    function h(e1) {
                        return e1 && e1 instanceof s.y ? e1 : e1 ? (0, i.I)(e1, o, ()=>new s.y(o)) : new s.y(o);
                    }
                    function p(e1, t1) {
                        n[e1] = g(e1).concat(t1);
                    }
                    function g(e1) {
                        return n[e1] || [];
                    }
                    function m(t1) {
                        return u[t1] = u[t1] || e1(f, t1);
                    }
                    function v() {
                        return f.backlog;
                    }
                }(void 0, "globalEE"), d = (0, n.Zm)();
                d.ee || (d.ee = c), r.d(t1, [
                    "P",
                    0,
                    o,
                    "ee",
                    0,
                    c
                ]);
            },
            2646 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    y: ()=>n
                });
                class n {
                    constructor(e1){
                        this.contextId = e1;
                    }
                }
            },
            9908 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    d: ()=>n,
                    p: ()=>i
                });
                var n = r(7836).ee.get("handle");
                function i(e1, t1, r, i, s) {
                    s ? (s.buffer([
                        e1
                    ], i), s.emit(e1, t1, r)) : (n.buffer([
                        e1
                    ], i), n.emit(e1, t1, r));
                }
            },
            3606 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    i: ()=>s
                });
                var n = r(9908);
                s.on = a;
                var i = s.handlers = {};
                function s(e1, t1, r, s) {
                    a(s || n.d, i, e1, t1, r);
                }
                function a(e1, t1, r, i, s) {
                    s || (s = "feature"), e1 || (e1 = n.d);
                    var a = t1[s] = t1[s] || {};
                    (a[r] = a[r] || []).push([
                        e1,
                        i
                    ]);
                }
            },
            3878 (e1, t1, r) {
                "use strict";
                function n(e1, t1) {
                    return {
                        capture: e1,
                        passive: !1,
                        signal: t1
                    };
                }
                function i(e1, t1, r = !1, i1) {
                    window.addEventListener(e1, t1, n(r, i1));
                }
                function s(e1, t1, r = !1, i) {
                    document.addEventListener(e1, t1, n(r, i));
                }
                r.d(t1, {
                    DD: ()=>s,
                    jT: ()=>n,
                    sp: ()=>i
                });
            },
            5607 (e1, t1, r) {
                "use strict";
                const n = (0, r(9566).bz)();
                r.d(t1, [
                    "W",
                    0,
                    n
                ]);
            },
            9566 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    LA: ()=>a,
                    ZF: ()=>o,
                    bz: ()=>s,
                    el: ()=>c
                });
                var n = r(6154);
                function i(e1, t1) {
                    return e1 ? 15 & e1[t1] : 16 * Math.random() | 0;
                }
                function s() {
                    const e1 = n.gm?.crypto || n.gm?.msCrypto;
                    let t1, r = 0;
                    return e1 && e1.getRandomValues && (t1 = e1.getRandomValues(new Uint8Array(30))), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("").map((e1)=>"x" === e1 ? i(t1, r++).toString(16) : "y" === e1 ? (3 & i() | 8).toString(16) : e1).join("");
                }
                function a(e1) {
                    const t1 = n.gm?.crypto || n.gm?.msCrypto;
                    let r, s = 0;
                    t1 && t1.getRandomValues && (r = t1.getRandomValues(new Uint8Array(e1)));
                    const a = [];
                    for(var o = 0; o < e1; o++)a.push(i(r, s++).toString(16));
                    return a.join("");
                }
                function o() {
                    return a(16);
                }
                function c() {
                    return a(32);
                }
            },
            2614 (e1, t1, r) {
                "use strict";
                r.d(t1, [
                    "BB",
                    0,
                    18e5,
                    "Wt",
                    0,
                    "NRBA_SESSION::",
                    "g",
                    0,
                    {
                        OFF: 0,
                        FULL: 1,
                        ERROR: 2
                    },
                    "iL",
                    0,
                    {
                        SAME_TAB: "same-tab",
                        CROSS_TAB: "cross-tab"
                    },
                    "tS",
                    0,
                    {
                        STARTED: "session-started",
                        PAUSE: "session-pause",
                        RESET: "session-reset",
                        RESUME: "session-resume",
                        UPDATE: "session-update"
                    },
                    "wk",
                    0,
                    144e5
                ]);
            },
            733 (e1, t1, r) {
                "use strict";
                function n(e1, t1) {
                    return function(e1) {
                        let t1 = 2166136261;
                        for(let r = 0; r < e1.length; r++)t1 ^= e1.charCodeAt(r), t1 = Math.imul(t1, 16777619);
                        return (t1 >>> 0).toString(16).padStart(8, "0");
                    }("".concat(String(e1), ":").concat(String(t1)));
                }
                r.d(t1, {
                    Y: ()=>n
                });
            },
            1863 (e1, t1, r) {
                "use strict";
                function n() {
                    return Math.floor(performance.now());
                }
                r.d(t1, {
                    t: ()=>n
                });
            },
            9119 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    L: ()=>s
                });
                var n = /([^?#]*)[^#]*(#[^?]*|$).*/, i = /([^?#]*)().*/;
                function s(e1, t1) {
                    return e1 ? e1.replace(t1 ? n : i, "$1$2") : e1;
                }
            },
            7485 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    D: ()=>i
                });
                var n = r(6154);
                function i(e1) {
                    if (0 === (e1 || "").indexOf("data:")) return {
                        protocol: "data"
                    };
                    try {
                        const t1 = new URL(e1, location.href), r = {
                            port: t1.port,
                            hostname: t1.hostname,
                            pathname: t1.pathname,
                            search: t1.search,
                            protocol: t1.protocol.slice(0, t1.protocol.indexOf(":")),
                            sameOrigin: t1.protocol === n.gm?.location?.protocol && t1.host === n.gm?.location?.host
                        };
                        return r.port && "" !== r.port || ("http:" === t1.protocol && (r.port = "80"), "https:" === t1.protocol && (r.port = "443")), r.pathname && "" !== r.pathname ? r.pathname.startsWith("/") || (r.pathname = "/".concat(r.pathname)) : r.pathname = "/", r;
                    } catch (e1) {
                        return {};
                    }
                }
            },
            7866 (e1, t1, r) {
                "use strict";
                r.d(t1, [
                    "Nc",
                    0,
                    /^\s*at Function code \(Function code:\d+:\d+\)\s*/i,
                    "cn",
                    0,
                    /^\s*(?:([^@]*)(?:\(.*?\))?@)?((?:file|http|https|chrome|safari-extension).*?):(\d+)(?::(\d+))?\s*$/i,
                    "fL",
                    0,
                    /^\s*at .+ \(eval at \S+ \((?:(?:file|http|https):[^)]+)?\)(?:, [^:]*:\d+:\d+)?\)$/i,
                    "h3",
                    0,
                    /function (.+?)\s*\(/,
                    "hB",
                    0,
                    /^\s*at (?:((?:\[object object\])?(?:[^(]*\([^)]*\))*[^()]*(?: \[as \S+\])?) )?\(?((?:file|http|https|chrome-extension):.*?)?:(\d+)(?::(\d+))?\)?\s*$/i
                ]);
            },
            944 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    R: ()=>i
                });
                var n = r(3241);
                function i(e1, t1) {
                    "function" == typeof console.debug && (console.debug("New Relic Warning: https://github.com/newrelic/newrelic-browser-agent/blob/main/docs/warning-codes.md#".concat(e1), t1), (0, n.W)({
                        drained: null,
                        type: "data",
                        name: "warn",
                        feature: "warn",
                        data: {
                            code: e1,
                            secondary: t1
                        }
                    }));
                }
            },
            8990 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    I: ()=>i
                });
                var n = Object.prototype.hasOwnProperty;
                function i(e1, t1, r) {
                    if (n.call(e1, t1)) return e1[t1];
                    var i = r();
                    if (Object.defineProperty && Object.keys) try {
                        return Object.defineProperty(e1, t1, {
                            value: i,
                            writable: !0,
                            enumerable: !1
                        }), i;
                    } catch (e1) {}
                    return e1[t1] = i, i;
                }
            },
            6389 (e1, t1, r) {
                "use strict";
                function n(e1, t1 = 500, r = {}) {
                    const n1 = r?.leading || !1;
                    let i;
                    return (...r)=>{
                        n1 && void 0 === i && (e1.apply(this, r), i = setTimeout(()=>{
                            i = clearTimeout(i);
                        }, t1)), n1 || (clearTimeout(i), i = setTimeout(()=>{
                            e1.apply(this, r);
                        }, t1));
                    };
                }
                function i(e1) {
                    let t1 = !1;
                    return (...r)=>{
                        t1 || (t1 = !0, e1.apply(this, r));
                    };
                }
                r.d(t1, {
                    J: ()=>i,
                    s: ()=>n
                });
            },
            1910 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    i: ()=>s
                });
                var n = r(944);
                const i = new Map;
                function s(...e1) {
                    return e1.every((e1)=>{
                        if (i.has(e1)) return i.get(e1);
                        const t1 = "function" == typeof e1 ? e1.toString() : "", r = t1.includes("[native code]"), s = t1.includes("nrWrapper");
                        return r || s || (0, n.R)(64, e1?.name || t1), i.set(e1, r), r;
                    });
                }
            },
            3304 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    A: ()=>i
                });
                var n = r(7836);
                function i(e1) {
                    try {
                        return JSON.stringify(e1, (()=>{
                            const e1 = new WeakSet;
                            return (t1, r)=>{
                                if ("object" == typeof r && null !== r) {
                                    if (e1.has(r)) return;
                                    e1.add(r);
                                }
                                return r;
                            };
                        })()) ?? "";
                    } catch (e1) {
                        try {
                            n.ee.emit("internal-error", [
                                e1
                            ]);
                        } catch (e1) {}
                        return "";
                    }
                }
            },
            9232 (e1, t1, r) {
                "use strict";
                r.d(t1, [
                    "f",
                    0,
                    {
                        MFE: "MFE",
                        BA: "BA"
                    }
                ]);
            },
            7560 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    N: ()=>a,
                    j: ()=>c
                });
                var n = r(9119), i = r(944);
                const s = (0, r(6389).J)((e1)=>(0, i.R)(80, e1));
                function a(e1) {
                    if (!Array.isArray(e1?.assets) || !e1.assets.length) return;
                    const t1 = e1.assets.map(o).filter(Boolean);
                    return t1.length ? {
                        assets: t1,
                        scripts: t1.filter((e1)=>e1.isScript)
                    } : void 0;
                }
                function o(e1) {
                    if (!e1 || "object" != typeof e1) return;
                    const { matcher: t1, type: r } = e1;
                    let i = "string" == typeof t1 && t1.endsWith(".js");
                    var a;
                    return void 0 !== r && (!function(e1) {
                        return "script" === e1 || "asset" === e1;
                    }(r) ? s(r) : i = function(e1) {
                        return "script" === e1;
                    }(r)), a = t1, "[object RegExp]" === Object.prototype.toString.call(a) ? {
                        pattern: t1,
                        test: (e1)=>(t1.lastIndex = 0, t1.test((0, n.L)(e1))),
                        isScript: i
                    } : "string" == typeof t1 && t1.length > 0 ? {
                        pattern: t1,
                        test: (e1)=>(0, n.L)(e1).includes(t1),
                        isScript: i
                    } : void s(t1);
                }
                function c(e1, t1, { scriptsOnly: r = !1 } = {}) {
                    if (!e1 || !t1) return !1;
                    return (r ? e1.scripts : e1.assets).some((e1)=>e1.test(t1));
                }
            },
            5718 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    xo: ()=>T,
                    AZ: ()=>v,
                    cI: ()=>g,
                    Qr: ()=>A,
                    QL: ()=>y
                });
                var n = r(6154), i = r(1863), s = r(9119), a = r(7866);
                class o {
                    dom = new c;
                    performance = new c;
                    constructor(e1){
                        this.url = e1, this.claimedBy = new Set;
                    }
                    get script() {
                        const e1 = Math.max(this.dom.start, this.performance.end);
                        return {
                            start: e1,
                            end: Math.max(this.dom.end, this.performance.end, e1)
                        };
                    }
                }
                class c {
                    start = 0;
                    end = 0;
                    value = void 0;
                }
                function d(e1 = ()=>{}, t1) {
                    return {
                        get: ()=>void 0 !== t1 ? t1 : e1(),
                        set: (e1)=>{
                            t1 = e1;
                        }
                    };
                }
                let u;
                try {
                    u = v(y())[0];
                } catch (e1) {
                    u = v(e1)[0];
                }
                const l = new Map;
                let f = [];
                const h = new WeakMap;
                function p(e1) {
                    let t1 = h.get(e1);
                    return t1 || (t1 = {
                        weighedAssetUrls: new Set,
                        recordManifestScriptWindow: (t1, r)=>{
                            t1 && (e1.scriptStart = e1.scriptStart > 0 ? Math.min(e1.scriptStart, t1) : t1), r && (e1.scriptEnd = e1.scriptEnd > 0 ? Math.max(e1.scriptEnd, r) : r);
                        }
                    }, h.set(e1, t1)), t1;
                }
                function g(e1) {
                    return l.get(e1);
                }
                function m(e1) {
                    const t1 = g(e1);
                    if (t1) return t1;
                    const r = new o(e1);
                    if (l.set(e1, r), l.size > 1e3) {
                        const e1 = l.keys().next().value;
                        l.delete(e1);
                    }
                    return r;
                }
                if (n.gm.MutationObserver && n.gm.document) new MutationObserver((e1)=>{
                    e1.forEach((e1)=>{
                        e1.addedNodes.forEach((e1)=>{
                            if ("SCRIPT" === e1.nodeName && e1.src) {
                                const t1 = m((0, s.L)(e1.src));
                                t1.dom.start = (0, i.t)(), t1.dom.value = e1;
                                const r = ()=>{
                                    t1.dom.end = (0, i.t)();
                                };
                                [
                                    "load",
                                    "error"
                                ].forEach((t1)=>e1.addEventListener(t1, r, {
                                        once: !0
                                    }));
                            }
                        });
                    });
                }).observe(n.gm.document, {
                    childList: !0,
                    subtree: !0
                });
                if (n.gm.PerformanceObserver?.supportedEntryTypes.includes("resource")) new PerformanceObserver((e1)=>{
                    e1.getEntries().forEach((e1)=>{
                        if (((e1)=>"script" === e1.initiatorType || [
                                "link",
                                "fetch"
                            ].includes(e1.initiatorType) && (0, s.L)(e1.name).endsWith(".js"))(e1)) {
                            const t1 = m((0, s.L)(e1.name));
                            t1.performance.start = Math.floor(e1.startTime), t1.performance.end = Math.floor(e1.responseEnd), t1.performance.value = e1;
                        }
                        if (!f.length) return;
                        const t1 = [];
                        f.forEach(({ test: r, addedAt: n }, s)=>{
                            (r(e1) || (0, i.t)() - n > 1e4) && t1.push(s);
                        }), f = f.filter((e1, r)=>!t1.includes(r));
                    });
                }).observe({
                    type: "resource",
                    buffered: !0
                });
                function v(e1) {
                    if (!e1 || "string" != typeof e1) return [];
                    const t1 = new Set, r = e1.split("\n");
                    for (const e1 of r){
                        const r = e1.match(a.cn) || e1.match(a.hB) || e1.match(a.fL);
                        if (r && r[2]) t1.add((0, s.L)(r[2]));
                        else {
                            const r = e1.match(/\(([^)]+\.js):\d+:\d+\)/) || e1.match(/^\s+at\s+([^\s(]+\.js):\d+:\d+/);
                            r && r[1] && t1.add((0, s.L)(r[1]));
                        }
                    }
                    return [
                        ...t1
                    ];
                }
                function y() {
                    let e1;
                    try {
                        const t1 = Error.stackTraceLimit;
                        Error.stackTraceLimit = 50, e1 = (new Error).stack, Error.stackTraceLimit = t1;
                    } catch (t1) {
                        e1 = (new Error).stack;
                    }
                    return e1;
                }
                function b(e1, t1) {
                    return (0, s.L)(e1.name) === t1;
                }
                function E(e1, t1) {
                    e1.fetchStart = Math.floor(t1.startTime), e1.fetchEnd = Math.floor(t1.responseEnd), e1.asset = t1.name, e1.type = t1.initiatorType, w(e1, t1);
                }
                function w(e1, t1) {
                    const r = (0, s.L)(t1.name), { weighedAssetUrls: n } = p(e1);
                    n.has(r) || (n.add(r), e1.totalWeight = (e1.totalWeight || 0) + (t1.transferSize || 0), "blocking" === t1.renderBlockingStatus ? e1.renderBlocking = !0 : "non-blocking" === t1.renderBlockingStatus && !0 !== e1.renderBlocking && (e1.renderBlocking = !1));
                }
                function R(e1, t1, r, n, i) {
                    if (w(e1, t1), "scripts" !== i && "all" !== i) return;
                    if ("all" === i || r.isScript) {
                        const r = Math.floor(t1.startTime), n = Math.floor(t1.responseEnd);
                        e1.fetchStart = e1.fetchStart > 0 ? Math.min(e1.fetchStart, r) : r, e1.fetchEnd = e1.fetchEnd > 0 ? Math.max(e1.fetchEnd, n) : n;
                    }
                    if (r.isScript) {
                        const r = g((0, s.L)(t1.name));
                        if (r) {
                            const t1 = ()=>{
                                const { start: t1, end: n } = r.script;
                                p(e1).recordManifestScriptWindow(t1, n);
                            };
                            t1(), !r.dom.end && r.dom.value && [
                                "load",
                                "error"
                            ].forEach((e1)=>r.dom.value.addEventListener(e1, t1, {
                                    once: !0
                                }));
                        }
                        n.resolved || (e1.asset = t1.name, e1.type = t1.initiatorType, n.resolved = !0);
                    }
                }
                function T(e1, t1) {
                    const r = t1?.manifest;
                    if (!r || !r.assets.length) return;
                    const s = {
                        resolved: !1
                    }, a = new Set(r.assets);
                    (n.gm.performance?.getEntriesByType("resource") || []).forEach((r)=>{
                        const n = [
                            ...a
                        ].find((e1)=>e1.test(r.name));
                        n && (R(e1, r, n, s, t1.timingMethod), a.delete(n));
                    }), a.size && function(e1, t1, r, s) {
                        n.gm.PerformanceObserver?.supportedEntryTypes?.includes("resource") && f.push({
                            addedAt: (0, i.t)(),
                            test: (n)=>{
                                const i = [
                                    ...t1
                                ].find((e1)=>e1.test(n.name));
                                return i && (R(e1, n, i, r, s), t1.delete(i)), 0 === t1.size;
                            }
                        });
                    }(e1, a, s, t1.timingMethod);
                }
                function A(e1) {
                    const t1 = e1?.id, r = {
                        registeredAt: (0, i.t)(),
                        reportedAt: void 0,
                        fetchStart: 0,
                        fetchEnd: 0,
                        scriptStart: 0,
                        scriptEnd: 0,
                        asset: void 0,
                        type: "unknown",
                        totalWeight: 0,
                        renderBlocking: void 0
                    }, a = y();
                    if (!a) return r;
                    const o = n.gm.performance?.getEntriesByType("navigation")?.[0]?.name || "";
                    try {
                        const e1 = v(a), c = (e1.length > 1 ? e1.filter((e1)=>u !== e1) : e1)[0];
                        if (!c) return r;
                        if (o.includes(c)) return r.asset = (0, s.L)(o), r.type = "inline", r;
                        r.correlation = g(c);
                        const l = r.correlation?.performance.value || n.gm.performance?.getEntriesByType("resource")?.find((e1)=>b(e1, c));
                        if (l) E(r, l);
                        else (function(e1) {
                            if (!e1 || !n.gm.document) return !1;
                            try {
                                const t1 = n.gm.document.querySelectorAll('link[rel="preload"][as="script"]');
                                for (const r of t1)if ((0, s.L)(r.href) === e1) return !0;
                            } catch (e1) {}
                            return !1;
                        })(c) && (r.asset = c, r.type = "preload"), function(e1, t1) {
                            n.gm.PerformanceObserver?.supportedEntryTypes?.includes("resource") && f.push({
                                addedAt: (0, i.t)(),
                                test: (r)=>!!b(r, t1) && (E(e1, r), !0)
                            });
                        }(r, c);
                        const h = r.correlation, m = !!t1 && !!h?.claimedBy.has(t1);
                        h && t1 && h.claimedBy.add(t1);
                        const y = ()=>{
                            const e1 = h?.script.start;
                            if (!m || !e1) return !1;
                            return r.registeredAt - e1 > 1e4;
                        };
                        let w = 0, R = 0;
                        p(r).recordManifestScriptWindow = (e1, t1)=>{
                            e1 && (w = w > 0 ? Math.min(w, e1) : e1), t1 && (R = R > 0 ? Math.max(R, t1) : t1);
                        }, Object.defineProperty(r, "scriptStart", d(()=>{
                            const e1 = y() ? r.registeredAt : h?.script.start ?? r.fetchEnd;
                            return w > 0 ? Math.min(e1, w) : e1;
                        })), Object.defineProperty(r, "scriptEnd", d(()=>{
                            const e1 = y() ? r.registeredAt : h?.script.end ?? r.registeredAt;
                            return R > 0 ? Math.max(e1, R) : e1;
                        }));
                    } catch (e1) {}
                    return r;
                }
            },
            5732 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    $5: ()=>m,
                    B5: ()=>g,
                    K6: ()=>u,
                    M$: ()=>o,
                    Ms: ()=>d,
                    NG: ()=>c,
                    Ux: ()=>h,
                    YA: ()=>p,
                    yx: ()=>l
                });
                var n = r(5718), i = r(7560), s = r(9119), a = r(9232);
                function o(e1) {
                    return e1?.type === a.f.MFE;
                }
                function c(e1, t1) {
                    if (!y(e1, t1)) return;
                    const r = t1.runtime.registeredEntities;
                    return r?.find((t1)=>t1.metadata.target.iframeInterfaceId === e1);
                }
                function d(e1, t1) {
                    if (!y(e1, t1)) return [];
                    const r = t1.runtime.registeredEntities;
                    return r?.filter((t1)=>String(t1.metadata.target.id) === String(e1)).map((e1)=>e1.metadata.target) || [];
                }
                function u(e1, t1) {
                    if (!y(e1, t1)) return [];
                    const r = t1.runtime.registeredEntities, n = (0, s.L)(e1), a = r?.filter((t1)=>{
                        const r = t1.metadata.target?.manifest;
                        return r ? (0, i.j)(r, e1, {
                            scriptsOnly: !1
                        }) : !!t1.metadata.timings?.asset && (0, s.L)(t1.metadata.timings.asset) === n;
                    });
                    return f(a).map((e1)=>e1.metadata.target);
                }
                function l(e1, t1) {
                    if (!y(e1, t1)) return [];
                    const r = t1.runtime.registeredEntities, n = r?.filter((t1)=>{
                        const r = t1.metadata.target?.manifest;
                        return r ? (0, i.j)(r, e1, {
                            scriptsOnly: !0
                        }) : !!t1.metadata.timings?.asset?.endsWith(e1);
                    });
                    return f(n).map((e1)=>e1.metadata.target);
                }
                function f(e1) {
                    if (!e1?.length) return e1 || [];
                    const t1 = new Map, r = [];
                    for (const n of e1){
                        const e1 = n.metadata?.timings?.asset;
                        if (!e1) {
                            r.push(n);
                            continue;
                        }
                        const i = "".concat(e1, "::").concat(n.metadata?.target?.id), s = t1.get(i);
                        if (s) {
                            if (s.metadata.target?.blocked && !n.metadata.target?.blocked) {
                                const e1 = r.indexOf(s);
                                -1 !== e1 && (r[e1] = n), t1.set(i, n);
                            }
                        } else t1.set(i, n), r.push(n);
                    }
                    return r;
                }
                function h(e1, t1) {
                    return v(t1) ? o(e1) ? e1.attributes : t1.agentRef.runtime.v2Target.attributes : {};
                }
                function p(e1, t1) {
                    return g(e1, t1) ? {
                        "child.id": e1.id,
                        "child.type": e1.type,
                        ...h(void 0, t1)
                    } : {};
                }
                function g(e1, t1) {
                    return o(e1) && !!v(t1) && t1.agentRef.init.api.register.duplicate_data_to_container;
                }
                function m(e1) {
                    if (!e1?.runtime) return [];
                    if (!y(!0, e1) || !e1.runtime.registeredEntities?.length) return [
                        e1.runtime.v2Target
                    ];
                    const t1 = [];
                    try {
                        var r = (0, n.AZ)((0, n.QL)());
                        let i = r.length - 1;
                        for(; r[i];)t1.push(...l(r[i--], e1));
                    } catch (e1) {}
                    const i = function(e1) {
                        const t1 = new Set, r = [];
                        for (const n of e1){
                            const e1 = n?.instance;
                            t1.has(e1) || (t1.add(e1), r.push(n));
                        }
                        return r;
                    }(t1);
                    return i.length || i.push(e1.runtime.v2Target), i;
                }
                function v(e1) {
                    return 2 === e1?.harvestEndpointVersion;
                }
                function y(e1, t1) {
                    return !!e1 && !!t1?.init.api.register.enabled;
                }
            },
            5289 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    GG: ()=>a,
                    Qr: ()=>c,
                    sB: ()=>o
                });
                var n = r(3878), i = r(6389);
                function s() {
                    return "undefined" == typeof document || "complete" === document.readyState;
                }
                function a(e1, t1) {
                    if (s()) return e1();
                    const r = (0, i.J)(e1), a = setInterval(()=>{
                        s() && (clearInterval(a), r());
                    }, 500);
                    (0, n.sp)("load", r, t1);
                }
                function o(e1) {
                    if (s()) return e1();
                    (0, n.DD)("DOMContentLoaded", e1);
                }
                function c(e1) {
                    if (s()) return e1();
                    (0, n.sp)("popstate", e1);
                }
            },
            384 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    Zm: ()=>c,
                    bQ: ()=>u,
                    dV: ()=>d,
                    pV: ()=>l
                });
                var n = r(6154), i = r(1863), s = r(944), a = r(1910);
                const o = {
                    beacon: "bam.nr-data.net",
                    errorBeacon: "bam.nr-data.net"
                };
                function c() {
                    return n.gm.NREUM || (n.gm.NREUM = {}), void 0 === n.gm.newrelic && (n.gm.newrelic = n.gm.NREUM), n.gm.NREUM;
                }
                function d() {
                    let e1 = c();
                    return e1.o || (e1.o = {
                        ST: n.gm.setTimeout,
                        SI: n.gm.setImmediate || n.gm.setInterval,
                        CT: n.gm.clearTimeout,
                        XHR: n.gm.XMLHttpRequest,
                        REQ: n.gm.Request,
                        EV: n.gm.Event,
                        PR: n.gm.Promise,
                        MO: n.gm.MutationObserver,
                        FETCH: n.gm.fetch,
                        WS: n.gm.WebSocket
                    }, (0, a.i)(...Object.values(e1.o))), e1;
                }
                function u(e1, t1) {
                    let r = c();
                    r.initializedAgents ??= {}, t1.initializedAt = {
                        ms: (0, i.t)(),
                        date: new Date
                    }, r.initializedAgents[e1] = t1, 2 === Object.keys(r.initializedAgents).length && (0, s.R)(69);
                }
                function l() {
                    return function() {
                        let e1 = c();
                        const t1 = e1.info || {};
                        e1.info = {
                            beacon: o.beacon,
                            errorBeacon: o.errorBeacon,
                            ...t1
                        };
                    }(), function() {
                        let e1 = c();
                        const t1 = e1.init || {};
                        e1.init = {
                            ...t1
                        };
                    }(), d(), function() {
                        let e1 = c();
                        const t1 = e1.loader_config || {};
                        e1.loader_config = {
                            ...t1
                        };
                    }(), c();
                }
                r.d(t1, [
                    "NT",
                    0,
                    o
                ]);
            },
            2843 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    G: ()=>s,
                    u: ()=>i
                });
                var n = r(3878);
                function i(e1, t1 = !1, r, i1) {
                    (0, n.DD)("visibilitychange", function() {
                        if (t1) return void ("hidden" === document.visibilityState && e1());
                        e1(document.visibilityState);
                    }, r, i1);
                }
                function s(e1, t1, r) {
                    (0, n.sp)("pagehide", e1, t1, r);
                }
            },
            8139 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    u: ()=>f
                });
                var n = r(7836), i = r(3434), s = r(8990), a = r(6154);
                const o = {}, c = a.gm.XMLHttpRequest, d = "addEventListener", u = "removeEventListener", l = "nr@wrapped:".concat(n.P);
                function f(e1, t1) {
                    var r = function(e1) {
                        return (e1 || n.ee).get("events");
                    }(e1);
                    if (o[r.debugId]++) return r;
                    o[r.debugId] = 1;
                    var f = (0, i.YM)(r, !0, t1);
                    function p(e1) {
                        f.inPlace(e1, [
                            d,
                            u
                        ], "-", g);
                    }
                    function g(e1, t1) {
                        return e1[1];
                    }
                    return "getPrototypeOf" in Object && (a.RI && h(document, p), c && h(c.prototype, p), h(a.gm, p)), r.on(d + "-start", function(e1, t1) {
                        var r = e1[1];
                        if (null !== r && ("function" == typeof r || "object" == typeof r) && "newrelic" !== e1[0]) {
                            var n = (0, s.I)(r, l, function() {
                                var e1 = {
                                    object: function() {
                                        if ("function" != typeof r.handleEvent) return;
                                        return r.handleEvent.apply(r, arguments);
                                    },
                                    function: r
                                }[typeof r];
                                return e1 ? f(e1, "fn-", null, e1.name || "anonymous") : r;
                            });
                            this.wrapped = e1[1] = n;
                        }
                    }), r.on(u + "-start", function(e1) {
                        e1[1] = this.wrapped || e1[1];
                    }), r;
                }
                function h(e1, t1, ...r) {
                    let n = e1;
                    for(; "object" == typeof n && !Object.prototype.hasOwnProperty.call(n, d);)n = Object.getPrototypeOf(n);
                    n && t1(n, ...r);
                }
            },
            3434 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    YM: ()=>d
                });
                var n = r(7836), i = r(5607), s = r(5732);
                const a = "nr@original:".concat(i.W);
                var o = Object.prototype.hasOwnProperty, c = !1;
                function d(e1, t1, r) {
                    return e1 || (e1 = n.ee), i.inPlace = function(e1, t1, r, n, s, a) {
                        r || (r = "");
                        const o = "-" === r.charAt(0);
                        for(let c = 0; c < t1.length; c++){
                            const d = t1[c], u = e1[d];
                            l(u) || (e1[d] = i(u, o ? d + r : r, n, d, s, a));
                        }
                    }, i.flag = a, i;
                    function i(t1, n, i, c, f, h) {
                        return l(t1) ? t1 : (n || (n = ""), nrWrapper[a] = t1, function(e1, t1, r) {
                            if (Object.defineProperty && Object.keys) try {
                                return Object.keys(e1).forEach(function(r) {
                                    Object.defineProperty(t1, r, {
                                        get: function() {
                                            return e1[r];
                                        },
                                        set: function(t1) {
                                            return e1[r] = t1, t1;
                                        }
                                    });
                                }), t1;
                            } catch (e1) {
                                u([
                                    e1
                                ], r);
                            }
                            for(var n in e1)o.call(e1, n) && (t1[n] = e1[n]);
                        }(t1, nrWrapper, e1), nrWrapper);
                        function nrWrapper() {
                            var a, o, l, p;
                            let g, m;
                            try {
                                o = this, a = [
                                    ...arguments
                                ], m = h ? (0, s.$5)(r) : [
                                    r?.runtime?.v2Target
                                ], l = "function" == typeof i ? i(a, o) : i || {};
                            } catch (t1) {
                                u([
                                    t1,
                                    "",
                                    [
                                        a,
                                        o,
                                        c
                                    ],
                                    l
                                ], e1);
                            }
                            d(n + "start", [
                                a,
                                o,
                                c,
                                m
                            ], l, f);
                            const v = performance.now();
                            let y;
                            try {
                                return p = t1.apply(o, a), y = performance.now(), p;
                            } catch (e1) {
                                throw y = performance.now(), d(n + "err", [
                                    a,
                                    o,
                                    e1,
                                    m
                                ], l, f), g = e1, g;
                            } finally{
                                const e1 = y - v, t1 = {
                                    start: v,
                                    end: y,
                                    duration: e1,
                                    isLongTask: e1 >= 50,
                                    methodName: c,
                                    thrownError: g
                                };
                                t1.isLongTask && d("long-task", [
                                    t1,
                                    o,
                                    m
                                ], l, f), d(n + "end", [
                                    a,
                                    o,
                                    p,
                                    m
                                ], l, f);
                            }
                        }
                    }
                    function d(r, n, i, s) {
                        if (!c || t1) {
                            var a = c;
                            c = !0;
                            try {
                                e1.emit(r, n, i, t1, s);
                            } catch (t1) {
                                u([
                                    t1,
                                    r,
                                    n,
                                    i
                                ], e1);
                            }
                            c = a;
                        }
                    }
                }
                function u(e1, t1) {
                    t1 || (t1 = n.ee);
                    try {
                        t1.emit("internal-error", e1);
                    } catch (e1) {}
                }
                function l(e1) {
                    return !(e1 && "function" == typeof e1 && e1.apply && !e1[a]);
                }
                r.d(t1, [
                    "Jt",
                    0,
                    a
                ]);
            },
            9300 (e1, t1, r) {
                "use strict";
                const n = r(860).K7.ajax;
                r.d(t1, [
                    "TZ",
                    0,
                    n,
                    "f5",
                    0,
                    "ajaxRequest.id",
                    "mo",
                    0,
                    {
                        NONE: "none",
                        FAILURES: "failures",
                        ALL: "all"
                    }
                ]);
            },
            3333 (e1, t1, r) {
                "use strict";
                var n = r(981);
                const i = r(860).K7.genericEvents, s = [
                    n.R.PA,
                    n.R.UA,
                    n.R.BP
                ];
                r.d(t1, [
                    "$v",
                    0,
                    {
                        RESOURCES: "experimental.resources",
                        REGISTER: "register"
                    },
                    "TZ",
                    0,
                    i,
                    "Zp",
                    0,
                    [
                        "auxclick",
                        "click",
                        "copy",
                        "keydown",
                        "paste",
                        "scrollend"
                    ],
                    "kd",
                    0,
                    s,
                    "qN",
                    0,
                    [
                        "focus",
                        "blur"
                    ]
                ]);
            },
            6774 (e1, t1, r) {
                "use strict";
                const n = r(860).K7.jserrors;
                r.d(t1, [
                    "T",
                    0,
                    n
                ]);
            },
            993 (e1, t1, r) {
                "use strict";
                const n = r(860).K7.logging;
                r.d(t1, [
                    "A$",
                    0,
                    {
                        OFF: 0,
                        ERROR: 1,
                        WARN: 2,
                        INFO: 3,
                        DEBUG: 4,
                        TRACE: 5
                    },
                    "TZ",
                    0,
                    n,
                    "p_",
                    0,
                    {
                        ERROR: "ERROR",
                        WARN: "WARN",
                        INFO: "INFO",
                        DEBUG: "DEBUG",
                        TRACE: "TRACE"
                    }
                ]);
            },
            3785 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    R: ()=>c,
                    b: ()=>d
                });
                var n = r(9908), i = r(1863), s = r(860), a = r(3969), o = r(993);
                function c(e1, t1, r = {}, c1 = o.p_.INFO, d = !0, u, l = (0, i.t)()) {
                    (0, n.p)(a.xV, [
                        "API/logging/".concat(c1.toLowerCase(), "/called")
                    ], void 0, s.K7.metrics, e1), (0, n.p)("log", [
                        l,
                        t1,
                        r,
                        c1,
                        d,
                        u
                    ], void 0, s.K7.logging, e1);
                }
                function d(e1) {
                    return "string" == typeof e1 && Object.values(o.p_).some((t1)=>t1 === e1.toUpperCase().trim());
                }
            },
            3969 (e1, t1, r) {
                "use strict";
                const n = r(860).K7.metrics;
                r.d(t1, [
                    "TZ",
                    0,
                    n,
                    "XG",
                    0,
                    "storeEventMetrics",
                    "xV",
                    0,
                    "storeSupportabilityMetrics"
                ]);
            },
            6630 (e1, t1, r) {
                "use strict";
                const n = r(860).K7.pageViewEvent;
                r.d(t1, [
                    "T",
                    0,
                    n
                ]);
            },
            782 (e1, t1, r) {
                "use strict";
                const n = r(860).K7.pageViewTiming;
                r.d(t1, [
                    "T",
                    0,
                    n
                ]);
            },
            6344 (e1, t1, r) {
                "use strict";
                var n = r(2614);
                const i = r(860).K7.sessionReplay, s = {
                    [n.g.ERROR]: 15e3,
                    [n.g.FULL]: 3e5,
                    [n.g.OFF]: 0
                };
                r.d(t1, [
                    "Qb",
                    0,
                    {
                        API: "api",
                        RESUME: "resume",
                        SWITCH_TO_FULL: "switchToFull",
                        INITIALIZE: "initialize",
                        PRELOAD: "preload"
                    },
                    "TZ",
                    0,
                    i,
                    "Vh",
                    0,
                    "errorDuringReplay",
                    "_s",
                    0,
                    {
                        DomContentLoaded: 0,
                        Load: 1,
                        FullSnapshot: 2,
                        IncrementalSnapshot: 3,
                        Meta: 4,
                        Custom: 5
                    },
                    "bc",
                    0,
                    {
                        RESET: {
                            message: "Session was reset",
                            sm: "Reset"
                        },
                        IMPORT: {
                            message: "Recorder failed to import",
                            sm: "Import"
                        },
                        TOO_MANY: {
                            message: "429: Too Many Requests",
                            sm: "Too-Many"
                        },
                        TOO_BIG: {
                            message: "Payload was too large",
                            sm: "Too-Big"
                        },
                        CROSS_TAB: {
                            message: "Session Entity was set to OFF on another tab",
                            sm: "Cross-Tab"
                        },
                        ENTITLEMENTS: {
                            message: "Session Replay is not allowed and will not be started",
                            sm: "Entitlement"
                        }
                    },
                    "yP",
                    0,
                    s
                ]);
            },
            5270 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    Aw: ()=>a,
                    SR: ()=>s,
                    rF: ()=>o
                });
                var n = r(384), i = r(7767);
                function s(e1) {
                    return !!(0, n.dV)().o.MO && (0, i.V)(e1) && !0 === e1?.session_trace.enabled;
                }
                function a(e1) {
                    return !0 === e1?.session_replay.preload && s(e1);
                }
                function o(e1, t1) {
                    try {
                        if ("string" == typeof t1?.type && "password" === t1.type.toLowerCase()) return "*".repeat(e1?.length || 0);
                        if (void 0 !== t1?.dataset?.nrUnmask || t1?.classList?.contains("nr-unmask")) return e1;
                    } catch (e1) {}
                    return "string" == typeof e1 ? e1.replace(/[\S]/g, "*") : "*".repeat(e1?.length || 0);
                }
            },
            3738 (e1, t1, r) {
                "use strict";
                const n = r(860).K7.sessionTrace, i = "-start", s = "-end", a = "fn" + i, o = "fn" + s;
                r.d(t1, [
                    "He",
                    0,
                    "bstResource",
                    "Kp",
                    0,
                    s,
                    "Lc",
                    0,
                    o,
                    "Rz",
                    0,
                    "pushState",
                    "TZ",
                    0,
                    n,
                    "bD",
                    0,
                    "resource",
                    "bc",
                    0,
                    {
                        CROSS_TAB: {
                            message: "Session Entity was set to OFF on another tab"
                        },
                        ENTITLEMENTS: {
                            message: "Session Trace is not allowed and will not be started"
                        },
                        RESET: {
                            message: "Session was reset"
                        },
                        SESSION_CHANGED: {
                            message: "Session identifier changed unexpectedly"
                        }
                    },
                    "d3",
                    0,
                    i,
                    "uP",
                    0,
                    a
                ]);
            },
            3962 (e1, t1, r) {
                "use strict";
                const n = r(860).K7.softNav;
                r.d(t1, [
                    "O2",
                    0,
                    {
                        INITIAL_PAGE_LOAD: "",
                        ROUTE_CHANGE: 1,
                        UNSPECIFIED: 2
                    },
                    "OV",
                    0,
                    "popstate",
                    "Qu",
                    0,
                    {
                        INTERACTION: 1,
                        AJAX: 2,
                        CUSTOM_END: 3,
                        CUSTOM_TRACER: 4
                    },
                    "TZ",
                    0,
                    n,
                    "ih",
                    0,
                    {
                        IP: "in progress",
                        PF: "pending finish",
                        FIN: "finished",
                        CAN: "cancelled"
                    },
                    "pP",
                    0,
                    "initialPageLoad",
                    "tC",
                    0,
                    [
                        "click",
                        "keydown",
                        "submit"
                    ]
                ]);
            },
            4234 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    W: ()=>i
                });
                var n = r(1687);
                class i {
                    constructor(e1, t1){
                        this.agentRef = e1, this.ee = e1?.ee, this.featureName = t1, this.blocked = !1;
                    }
                    deregisterDrain() {
                        (0, n.x3)(this.agentRef, this.featureName);
                    }
                }
            },
            7767 (e1, t1, r) {
                "use strict";
                var n = r(6154);
                r.d(t1, [
                    "V",
                    0,
                    (e1)=>n.RI && !0 === e1?.privacy.cookies_enabled
                ]);
            },
            8362 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    d: ()=>s
                });
                var n = r(9566), i = r(1741);
                class s extends i.W {
                    agentIdentifier = (0, n.LA)(16);
                }
            },
            1741 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    W: ()=>s
                });
                var n = r(944), i = r(4261);
                class s {
                    #e(e1, ...t1) {
                        if (this[e1] !== s.prototype[e1]) return this[e1](...t1);
                        (0, n.R)(35, e1);
                    }
                    addPageAction(e1, t1) {
                        return this.#e(i.hG, e1, t1);
                    }
                    register(e1) {
                        return this.#e(i.eY, e1);
                    }
                    recordCustomEvent(e1, t1) {
                        return this.#e(i.fF, e1, t1);
                    }
                    setPageViewName(e1, t1) {
                        return this.#e(i.Fw, e1, t1);
                    }
                    setCustomAttribute(e1, t1, r) {
                        return this.#e(i.cD, e1, t1, r);
                    }
                    noticeError(e1, t1) {
                        return this.#e(i.o5, e1, t1);
                    }
                    setUserId(e1, t1 = !1) {
                        return this.#e(i.Dl, e1, t1);
                    }
                    setApplicationVersion(e1) {
                        return this.#e(i.nb, e1);
                    }
                    setErrorHandler(e1) {
                        return this.#e(i.bt, e1);
                    }
                    addRelease(e1, t1) {
                        return this.#e(i.k6, e1, t1);
                    }
                    log(e1, t1) {
                        return this.#e("log", e1, t1);
                    }
                    start() {
                        return this.#e("start");
                    }
                    finished(e1) {
                        return this.#e(i.BL, e1);
                    }
                    recordReplay() {
                        return this.#e(i.CH);
                    }
                    pauseReplay() {
                        return this.#e(i.Tb);
                    }
                    addToTrace(e1) {
                        return this.#e(i.U2, e1);
                    }
                    setCurrentRouteName(e1) {
                        return this.#e(i.PA, e1);
                    }
                    interaction(e1) {
                        return this.#e(i.dT, e1);
                    }
                    wrapLogger(e1, t1, r) {
                        return this.#e(i.Wb, e1, t1, r);
                    }
                    measure(e1, t1) {
                        return this.#e(i.V1, e1, t1);
                    }
                    consent(e1) {
                        return this.#e(i.Pv, e1);
                    }
                }
            },
            4261 (e1, t1, r) {
                "use strict";
                r.d(t1, [
                    "BL",
                    0,
                    "finished",
                    "CH",
                    0,
                    "recordReplay",
                    "Dl",
                    0,
                    "setUserId",
                    "Fw",
                    0,
                    "setPageViewName",
                    "PA",
                    0,
                    "setCurrentRouteName",
                    "Pv",
                    0,
                    "consent",
                    "Tb",
                    0,
                    "pauseReplay",
                    "U2",
                    0,
                    "addToTrace",
                    "V1",
                    0,
                    "measure",
                    "Wb",
                    0,
                    "wrapLogger",
                    "bt",
                    0,
                    "setErrorHandler",
                    "cD",
                    0,
                    "setCustomAttribute",
                    "dT",
                    0,
                    "interaction",
                    "eY",
                    0,
                    "register",
                    "fF",
                    0,
                    "recordCustomEvent",
                    "hG",
                    0,
                    "addPageAction",
                    "hw",
                    0,
                    "api-ixn-",
                    "k6",
                    0,
                    "addRelease",
                    "nb",
                    0,
                    "setApplicationVersion",
                    "o5",
                    0,
                    "noticeError"
                ]);
            },
            1738 (e1, t1, r) {
                "use strict";
                r.d(t1, {
                    U: ()=>l,
                    Y: ()=>u
                });
                var n = r(3241), i = r(9908), s = r(1863), a = r(944), o = r(3969), c = r(8362), d = r(860);
                function u(e1, t1, r, s) {
                    const u = s || r;
                    !u || u[e1] && u[e1] !== c.d.prototype[e1] || (u[e1] = function() {
                        (0, i.p)(o.xV, [
                            "API/" + e1 + "/called"
                        ], void 0, d.K7.metrics, r.ee), (0, n.W)({
                            drained: !!r.runtime?.activatedFeatures,
                            type: "data",
                            name: "api",
                            feature: "api-" + e1,
                            data: {}
                        });
                        try {
                            return t1.apply(this, arguments);
                        } catch (e1) {
                            (0, a.R)(23, e1);
                        }
                    });
                }
                function l(e1, t1, r, n, a) {
                    const o = e1.info;
                    null === r ? delete o.jsAttributes[t1] : o.jsAttributes[t1] = r, (a || null === r) && (0, i.p)("api-" + n, [
                        (0, s.t)(),
                        t1,
                        r
                    ], void 0, "session", e1.ee);
                }
            },
            8374 (e1, t1, r) {
                r.nc = (()=>{
                    try {
                        return document?.currentScript?.nonce;
                    } catch (e1) {}
                    return "";
                })();
            },
            860 (e1, t1, r) {
                "use strict";
                const n = "events", i = "jserrors", s = "browser/blobs", a = "browser/logs", o = {
                    ajax: "ajax",
                    genericEvents: "generic_events",
                    jserrors: i,
                    logging: "logging",
                    metrics: "metrics",
                    pageAction: "page_action",
                    pageViewEvent: "page_view_event",
                    pageViewTiming: "page_view_timing",
                    sessionReplay: "session_replay",
                    sessionTrace: "session_trace",
                    softNav: "soft_navigations"
                }, c = {
                    [o.pageViewEvent]: 1,
                    [o.pageViewTiming]: 2,
                    [o.metrics]: 3,
                    [o.jserrors]: 4,
                    [o.softNav]: 5,
                    [o.ajax]: 6,
                    [o.sessionTrace]: 7,
                    [o.sessionReplay]: 8,
                    [o.logging]: 9,
                    [o.genericEvents]: 10
                }, d = {
                    [o.pageViewEvent]: "rum",
                    [o.pageViewTiming]: n,
                    [o.ajax]: n,
                    [o.softNav]: n,
                    [o.metrics]: i,
                    [o.jserrors]: i,
                    [o.sessionTrace]: s,
                    [o.sessionReplay]: s,
                    [o.logging]: a,
                    [o.genericEvents]: "ins"
                };
                r.d(t1, [
                    "$J",
                    0,
                    d,
                    "K7",
                    0,
                    o,
                    "P3",
                    0,
                    c,
                    "XX",
                    0,
                    i,
                    "Yy",
                    0,
                    a,
                    "df",
                    0,
                    s,
                    "hg",
                    0,
                    "connect"
                ]);
            }
        };
        const t1 = {};
        function r(n) {
            const i = t1[n];
            if (void 0 !== i) return i.exports;
            const s = t1[n] = {
                exports: {}
            };
            return e1[n](s, s.exports, r), s.exports;
        }
        r.m = e1, r.d = (e1, t1)=>{
            if (Array.isArray(t1)) for(var n = 0; n < t1.length;){
                var i = t1[n++], s = t1[n++];
                r.o(e1, i) ? 0 === s && n++ : 0 === s ? Object.defineProperty(e1, i, {
                    enumerable: !0,
                    value: t1[n++]
                }) : Object.defineProperty(e1, i, {
                    enumerable: !0,
                    get: s
                });
            }
            else for(var i in t1)r.o(t1, i) && !r.o(e1, i) && Object.defineProperty(e1, i, {
                enumerable: !0,
                get: t1[i]
            });
        }, r.f = {}, r.e = (e1)=>Promise.all(Object.keys(r.f).reduce((t1, n)=>(r.f[n](e1, t1), t1), [])), r.u = (e1)=>({
                212: "nr-spa-compressor",
                238: "nr-spa-iframe-message-handler",
                249: "nr-spa-recorder",
                478: "nr-spa"
            })[e1] + "-1.323.0.min.js", r.o = (e1, t1)=>Object.prototype.hasOwnProperty.call(e1, t1), (()=>{
            const e1 = {}, t1 = "NRBA-1.323.0.PROD:";
            r.l = (n, i, s, a)=>{
                if (e1[n]) return void e1[n].push(i);
                let o, c;
                if (void 0 !== s) {
                    const e1 = document.getElementsByTagName("script");
                    for(var d = 0; d < e1.length; d++){
                        const r = e1[d];
                        if (r.getAttribute("src") == n || r.getAttribute("data-webpack") == t1 + s) {
                            o = r;
                            break;
                        }
                    }
                }
                if (!o) {
                    c = !0;
                    var u = {
                        478: "sha512-ORjtmy+nQMgxbu0os8+oTRa5sPzbinyuWSvpZrrstVLIaHofRRlfODdH+oUmkIgeQpM+vPf3vG/4RzvCsFVh1A==",
                        249: "sha512-o7+K6xC0z3TqynjVxpd+jgiSgqy8rrPeRcUSqt5J0Rqg5Su5CycLMYfpwiM3WBCHiNDrG5aZoXJQ6HRc335XYQ==",
                        212: "sha512-kRvBt1IYQDBnClTEWNaE8sDFqbXXM3Vdyf972Uf4MFbJxl7u3KmdO+jdB1H4achPEoT9YtNXHswaESey6sCH0A==",
                        238: "sha512-U5EGmyYbFVR2UMNAuZJ7fTgVVtPa5b8RPMySDwXo7z3frRdkUJ2x1VAQTLQCeBab8VlGVGRV8FiSHIn/pwN72A=="
                    };
                    o = document.createElement("script"), o.charset = "utf-8", r.nc && o.setAttribute("nonce", r.nc), o.setAttribute("data-webpack", t1 + s), o.src = n, 0 !== o.src.indexOf(window.location.origin + "/") && (o.crossOrigin = "anonymous"), u[a] && (o.integrity = u[a]);
                }
                e1[n] = [
                    i
                ];
                const l = (t1, r)=>{
                    o.onerror = o.onload = null, clearTimeout(f);
                    const i = e1[n];
                    if (delete e1[n], o.parentNode?.removeChild(o), i?.forEach((e1)=>e1(r)), t1) return t1(r);
                }, f = setTimeout(l.bind(null, void 0, {
                    type: "timeout",
                    target: o
                }), 12e4);
                o.onerror = l.bind(null, o.onerror), o.onload = l.bind(null, o.onload), c && document.head.appendChild(o);
            };
        })(), r.r = (e1)=>{
            Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e1, "__esModule", {
                value: !0
            });
        }, r.p = "https://js-agent.newrelic.com/", (()=>{
            const e1 = {
                38: 0,
                788: 0
            };
            r.f.j = (t1, n)=>{
                let i = r.o(e1, t1) ? e1[t1] : void 0;
                if (0 !== i) {
                    if (i) n.push(i[2]);
                    else {
                        const s = new Promise((r, n)=>i = e1[t1] = [
                                r,
                                n
                            ]);
                        n.push(i[2] = s);
                        const a = r.p + r.u(t1), o = new Error, c = (n)=>{
                            if (r.o(e1, t1) && (i = e1[t1], 0 !== i && (e1[t1] = void 0), i)) {
                                const e1 = n && ("load" === n.type ? "missing" : n.type), r = n && n.target && n.target.src;
                                o.message = "Loading chunk " + t1 + " failed: (" + e1 + ": " + r + ")", o.name = "ChunkLoadError", o.type = e1, o.request = r, i[1](o);
                            }
                        };
                        r.l(a, c, "chunk-" + t1, t1);
                    }
                }
            };
            const t1 = (t1, n)=>{
                let [i, s, a] = n;
                var o, c, d = 0;
                if (i.some((t1)=>0 !== e1[t1])) {
                    for(o in s)r.o(s, o) && (r.m[o] = s[o]);
                    if (a) a(r);
                }
                for(t1 && t1(n); d < i.length; d++)c = i[d], r.o(e1, c) && e1[c] && e1[c][0](), e1[c] = 0;
            }, n = self["webpackChunk:NRBA-1.323.0.PROD"] = self["webpackChunk:NRBA-1.323.0.PROD"] || [];
            n.forEach(t1.bind(null, 0)), n.push = t1.bind(null, n.push.bind(n));
        })(), (()=>{
            "use strict";
            r(8374);
            var e1 = r(8362), t1 = r(860);
            const n = Object.values(t1.K7);
            var i = r(384), s = r(1741);
            var a = r(2555), o = r(3333), c = r(9300);
            const d = (e1)=>{
                if (!e1 || "string" != typeof e1) return !1;
                try {
                    document.createDocumentFragment().querySelector(e1);
                } catch  {
                    return !1;
                }
                return !0;
            };
            var u = r(2614), l = r(944), f = r(8122);
            const h = "[data-nr-mask]", p = (e1)=>(0, f.a)(e1, (()=>{
                    const e1 = {
                        feature_flags: [],
                        experimental: {
                            register: !1,
                            resources: !1,
                            iframe_bridge: !1,
                            iframe_domains: []
                        },
                        mask_selector: "*",
                        block_selector: "[data-nr-block]",
                        mask_input_options: {
                            color: !1,
                            date: !1,
                            "datetime-local": !1,
                            email: !1,
                            month: !1,
                            number: !1,
                            range: !1,
                            search: !1,
                            tel: !1,
                            text: !1,
                            time: !1,
                            url: !1,
                            week: !1,
                            textarea: !1,
                            select: !1,
                            password: !0
                        }
                    };
                    return {
                        ajax: {
                            deny_list: void 0,
                            block_internal: !0,
                            enabled: !0,
                            autoStart: !0,
                            capture_payloads: c.mo.NONE
                        },
                        api: {
                            register: {
                                get enabled () {
                                    return e1.feature_flags.includes(o.$v.REGISTER) || e1.experimental.register;
                                },
                                set enabled (t){
                                    e1.experimental.register = t;
                                },
                                duplicate_data_to_container: !1,
                                get allow_iframe_bridge () {
                                    return e1.feature_flags.includes(o.$v.IFRAME_BRIDGE) || e1.experimental.iframe_bridge;
                                },
                                set allow_iframe_bridge (t){
                                    e1.experimental.iframe_bridge = t;
                                },
                                get iframe_domains () {
                                    return e1.experimental.iframe_domains;
                                },
                                set iframe_domains (t){
                                    Array.isArray(t) ? e1.experimental.iframe_domains = t : (0, l.R)(1, t);
                                }
                            }
                        },
                        browser_consent_mode: {
                            enabled: !1
                        },
                        distributed_tracing: {
                            enabled: void 0,
                            exclude_newrelic_header: void 0,
                            cors_use_newrelic_header: void 0,
                            cors_use_tracecontext_headers: void 0,
                            allowed_origins: void 0
                        },
                        get feature_flags () {
                            return e1.feature_flags;
                        },
                        set feature_flags (t){
                            e1.feature_flags = t;
                        },
                        generic_events: {
                            enabled: !0,
                            autoStart: !0
                        },
                        harvest: {
                            interval: 30
                        },
                        jserrors: {
                            enabled: !0,
                            autoStart: !0
                        },
                        logging: {
                            enabled: !0,
                            autoStart: !0
                        },
                        metrics: {
                            enabled: !0,
                            autoStart: !0
                        },
                        obfuscate: void 0,
                        page_action: {
                            enabled: !0
                        },
                        page_view_event: {
                            enabled: !0,
                            autoStart: !0
                        },
                        page_view_timing: {
                            enabled: !0,
                            autoStart: !0
                        },
                        performance: {
                            capture_marks: !1,
                            capture_measures: !1,
                            capture_detail: !0,
                            resources: {
                                get enabled () {
                                    return e1.feature_flags.includes(o.$v.RESOURCES) || e1.experimental.resources;
                                },
                                set enabled (t){
                                    e1.experimental.resources = t;
                                },
                                asset_types: [],
                                first_party_domains: [],
                                ignore_newrelic: !0
                            }
                        },
                        privacy: {
                            cookies_enabled: !0
                        },
                        proxy: {
                            assets: void 0,
                            beacon: void 0
                        },
                        session: {
                            expiresMs: u.wk,
                            inactiveMs: u.BB
                        },
                        session_replay: {
                            autoStart: !0,
                            enabled: !1,
                            preload: !1,
                            sampling_rate: 10,
                            error_sampling_rate: 100,
                            collect_fonts: !1,
                            inline_images: !1,
                            fix_stylesheets: !0,
                            mask_all_inputs: !0,
                            get mask_text_selector () {
                                return e1.mask_selector;
                            },
                            set mask_text_selector (t){
                                d(t) ? e1.mask_selector = "".concat(t, ",").concat(h) : "" === t || null === t ? e1.mask_selector = h : (0, l.R)(5, t);
                            },
                            get block_class () {
                                return "nr-block";
                            },
                            get ignore_class () {
                                return "nr-ignore";
                            },
                            get mask_text_class () {
                                return "nr-mask";
                            },
                            get block_selector () {
                                return e1.block_selector;
                            },
                            set block_selector (t){
                                d(t) ? e1.block_selector += ",".concat(t) : "" !== t && (0, l.R)(6, t);
                            },
                            get mask_input_options () {
                                return e1.mask_input_options;
                            },
                            set mask_input_options (t){
                                t && "object" == typeof t ? e1.mask_input_options = {
                                    ...t,
                                    password: !0
                                } : (0, l.R)(7, t);
                            }
                        },
                        session_trace: {
                            enabled: !0,
                            autoStart: !0
                        },
                        soft_navigations: {
                            enabled: !0,
                            autoStart: !0
                        },
                        ssl: void 0,
                        user_actions: {
                            enabled: !0,
                            elementAttributes: [
                                "id",
                                "className",
                                "tagName",
                                "type"
                            ]
                        },
                        web_sockets: {
                            enabled: !1
                        }
                    };
                })());
            var g = r(6154), m = r(9324);
            let v = 0;
            const y = {
                buildEnv: "PROD",
                distMethod: "CDN",
                version: m.x,
                originTime: g.WN
            }, b = {
                consented: !1
            }, E = {
                activatedFeatures: void 0,
                appMetadata: {},
                configured: !1,
                get consented () {
                    return this.session?.state?.consent || b.consented;
                },
                set consented (e){
                    b.consented = e;
                },
                customTransaction: void 0,
                denyList: [],
                disabled: !1,
                drainRegistry: new Map,
                connector: void 0,
                harvester: void 0,
                v2Target: void 0,
                isolatedBacklog: !1,
                isRecording: !1,
                loaderType: void 0,
                maxBytes: 3e4,
                obfuscator: void 0,
                onerror: void 0,
                ptid: void 0,
                releaseIds: {},
                session: void 0,
                timeKeeper: void 0,
                registeredEntities: [],
                jsAttributesMetadata: {
                    bytes: 0
                },
                get harvestCount () {
                    return ++v;
                },
                listeningForIframeMessages: !1
            };
            var w = r(9232);
            var R = r(7836), T = r(3241);
            const A = {
                accountID: void 0,
                trustKey: void 0,
                agentID: void 0,
                licenseKey: void 0,
                applicationID: void 0,
                xpid: void 0
            };
            var S = r(9908), x = r(9752);
            function O(e1, t1 = {}, n, o) {
                let { init: c, info: d, loader_config: u, runtime: l = {}, exposed: h = !0 } = t1;
                if (!d) {
                    const e1 = (0, i.pV)();
                    c = e1.init, d = e1.info, u = e1.loader_config;
                }
                var m;
                e1.init = p(c || {}), e1.loader_config = (m = u || {}, (0, f.a)(m, A)), d.jsAttributes ??= {}, g.bv && (d.jsAttributes.isWorker = !0), e1.info = (0, a.D)(d);
                const v = e1.init;
                e1.runtime ??= ((e1)=>{
                    const t1 = (0, f.a)(e1, E), r = Object.keys(y).reduce((e1, t1)=>(e1[t1] = {
                            value: y[t1],
                            writable: !1,
                            configurable: !0,
                            enumerable: !0
                        }, e1), {});
                    return Object.defineProperties(t1, r);
                })(l), e1.runtime.v2Target ??= {
                    type: w.f.BA,
                    instance: e1.agentIdentifier,
                    get id () {
                        return e1.runtime.appMetadata?.agents?.[0]?.entityGuid;
                    },
                    get attributes () {
                        return {
                            "entity.guid": this.id,
                            appId: e1.info.applicationID
                        };
                    }
                }, v.proxy.assets && ((e1)=>{
                    const t1 = e1.startsWith("http");
                    e1 += "/", r.p = t1 ? e1 : "https://" + e1;
                })(v.proxy.assets), e1.runtime.configured || (Object.defineProperty(e1, "beacons", {
                    get: ()=>[
                            e1.info.beacon,
                            e1.info.errorBeacon,
                            e1.init.proxy.assets,
                            e1.init.proxy.beacon
                        ].filter(Boolean)
                }), Object.defineProperty(e1.runtime, "denyList", {
                    get: ()=>[
                            ...e1.init.ajax.deny_list || [],
                            ...e1.init.ajax.block_internal ? e1.beacons : []
                        ]
                }), e1.runtime.ptid = e1.agentIdentifier, function(e1) {
                    const t1 = (0, i.pV)();
                    Object.getOwnPropertyNames(s.W.prototype).forEach((r)=>{
                        const n = s.W.prototype[r];
                        if ("function" != typeof n || "constructor" === n) return;
                        let i = t1[r];
                        e1[r] && !1 !== e1.exposed && "micro-agent" !== e1.runtime?.loaderType && (t1[r] = (...t1)=>{
                            const n = e1[r](...t1);
                            return i ? i(...t1) : n;
                        });
                    });
                }(e1), e1.runtime.loaderType = n, e1.ee = R.ee.get(e1.agentIdentifier), e1.exposed = h, (0, T.W)({
                    drained: !!e1.runtime.activatedFeatures,
                    type: "lifecycle",
                    name: "initialize",
                    feature: void 0,
                    data: e1.config
                }), e1.init.api.register.allow_iframe_bridge && g.gm.addEventListener("message", (t1)=>{
                    "string" == typeof t1.data?.type && t1.data.type.startsWith(x.Pl) && (0, S.p)("iframe-message", [
                        t1
                    ], void 0, "IFRAME", e1.ee);
                }), e1.runtime.configured = !0);
            }
            var _ = r(1863), k = r(4261), N = r(1738);
            var L = r(1687), M = r(4234), P = r(5289), I = r(5270), j = r(7767), C = r(6389), D = r(7699);
            const B = new WeakSet, H = new WeakMap;
            class W extends M.W {
                constructor(e1, t1){
                    super(e1, t1), this.abortHandler = void 0, this.featAggregate = void 0, this.loadedSuccessfully = void 0, this.onAggregateImported = new Promise((e1)=>{
                        this.loadedSuccessfully = e1;
                    }), this.deferred = Promise.resolve(), !1 === e1.init[this.featureName].autoStart ? this.deferred = new Promise((t1, r)=>{
                        this.ee.on("manual-start-all", (0, C.J)(()=>{
                            (0, L.Ak)(e1, this.featureName), t1();
                        }));
                    }) : (0, L.Ak)(e1, t1);
                }
                importAggregator(e1, t1, n = {}) {
                    if (this.featAggregate) return;
                    const i = async ()=>{
                        if (await this.deferred, this.#t(e1), !(0, a.f)(e1.info)) return (0, l.R)(43), e1.ee.abort(), void this.loadedSuccessfully(!1);
                        try {
                            await async function(e1, t1, n) {
                                if (H.has(e1)) return H.get(e1);
                                const i = (async ()=>{
                                    if ((0, j.V)(e1.init)) try {
                                        const { setupAgentSession: t1 } = await r.e(478).then(r.bind(r, 8766));
                                        t1(e1);
                                    } catch (e1) {
                                        (0, l.R)(20, e1), t1.emit("internal-error", [
                                            e1
                                        ]), (0, S.p)(D.qh, [
                                            e1
                                        ], void 0, n, t1);
                                    }
                                    if (e1.init.api.register.allow_iframe_bridge) try {
                                        const { setupIframeMFEMessageListener: t1 } = await r.e(238).then(r.bind(r, 6417));
                                        t1(e1);
                                    } catch (e1) {
                                        (0, l.R)(23, e1);
                                    }
                                    const [{ Connector: i }, { Harvester: s }] = await Promise.all([
                                        r.e(478).then(r.bind(r, 6589)),
                                        r.e(478).then(r.bind(r, 5237))
                                    ]);
                                    e1.runtime.connector = new i(e1), e1.runtime.harvester = new s(e1);
                                    const a = Object.values(e1.features).filter((t1)=>e1.runtime.drainRegistry.has(t1.featureName));
                                    Promise.all(a.map((e1)=>e1.onAggregateImported)).then(()=>e1.runtime.harvester.startTimer());
                                })();
                                H.set(e1, i), await i;
                            }(e1, this.ee, this.featureName);
                        } catch (e1) {
                            return (0, l.R)(79, e1), this.ee.abort(), void this.loadedSuccessfully(!1);
                        }
                        try {
                            if (!this.#r(this.featureName, e1.runtime.session, e1.init)) return this.abortHandler?.(), (0, L.Ze)(this.agentRef, this.featureName), void this.loadedSuccessfully(!1);
                            const { Aggregate: r } = await t1();
                            this.featAggregate = new r(e1, n), e1.runtime.harvester.initializedAggregates.push(this.featAggregate), this.loadedSuccessfully(!0);
                        } catch (e1) {
                            (0, l.R)(34, e1), this.abortHandler?.(), (0, L.Ze)(this.agentRef, this.featureName, !0), this.loadedSuccessfully(!1);
                        }
                    };
                    g.RI ? (0, P.GG)(()=>i(), !0) : i();
                }
                #r(e1, r, n) {
                    if (this.blocked) return !1;
                    switch(e1){
                        case t1.K7.sessionReplay:
                            return (0, I.SR)(n) && !!r;
                        case t1.K7.sessionTrace:
                            return !!r;
                        default:
                            return !0;
                    }
                }
                #t(e1) {
                    if (!B.has(e1) && (B.add(e1), !(0, a.f)(e1.info))) {
                        const t1 = (0, i.pV)();
                        let r = {
                            ...t1.info?.jsAttributes
                        };
                        try {
                            r = {
                                ...r,
                                ...e1.info?.jsAttributes
                            };
                        } catch (e1) {}
                        O(e1, {
                            ...t1,
                            info: {
                                ...t1.info,
                                jsAttributes: r
                            },
                            runtime: e1.runtime
                        }, e1.runtime.loaderType);
                    }
                }
            }
            var U = r(6630);
            class K extends W {
                static featureName = U.T;
                constructor(e1){
                    var t1;
                    super(e1, U.T), this.setupInspectionEvents(), t1 = e1, (0, N.Y)(k.Fw, function(e1, r) {
                        "string" == typeof e1 && ("/" !== e1.charAt(0) && (e1 = "/" + e1), t1.runtime.customTransaction = (r || "http://custom.transaction") + e1, (0, S.p)("api-" + k.Fw, [
                            (0, _.t)()
                        ], void 0, void 0, t1.ee));
                    }, t1), this.importAggregator(e1, ()=>e1.init.feature_flags.includes("rum_v2") ? r.e(478).then(r.bind(r, 908)) : r.e(478).then(r.bind(r, 7927)));
                }
                setupInspectionEvents() {
                    const e1 = (e1, t1)=>{
                        e1 && (0, T.W)({
                            timeStamp: e1.timeStamp,
                            loaded: "complete" === e1.target.readyState,
                            type: "window",
                            name: t1,
                            data: e1.target.location + ""
                        });
                    };
                    (0, P.sB)((t1)=>{
                        e1(t1, "DOMContentLoaded");
                    }), (0, P.GG)((t1)=>{
                        e1(t1, "load");
                    }), (0, P.Qr)((t1)=>{
                        e1(t1, "navigate");
                    }), this.ee.on(u.tS.UPDATE, (e1, t1)=>{
                        (0, T.W)({
                            type: "lifecycle",
                            name: "session",
                            data: t1
                        });
                    });
                }
            }
            class F extends e1.d {
                constructor(e1){
                    var t1;
                    (super(), g.gm) ? (this.features = {}, (0, i.bQ)(this.agentIdentifier, this), this.desiredFeatures = new Set(e1.features || []), this.desiredFeatures.add(K), O(this, e1, e1.loaderType || "agent"), t1 = this, (0, N.Y)(k.cD, function(e1, r, n = !1) {
                        if ("string" == typeof e1) {
                            if ([
                                "string",
                                "number",
                                "boolean"
                            ].includes(typeof r) || null === r) return (0, N.U)(t1, e1, r, k.cD, n);
                            (0, l.R)(40, typeof r);
                        } else (0, l.R)(39, typeof e1);
                    }, t1), function(e1) {
                        (0, N.Y)(k.Dl, function(t1, r = !1) {
                            if ("string" != typeof t1 && null !== t1) return void (0, l.R)(41, typeof t1);
                            const n = e1.info.jsAttributes["enduser.id"];
                            r && null != n && n !== t1 ? (0, S.p)("api-setUserIdAndResetSession", [
                                t1
                            ], void 0, "session", e1.ee) : (0, N.U)(e1, "enduser.id", t1, k.Dl, !0);
                        }, e1);
                    }(this), function(e1) {
                        (0, N.Y)(k.nb, function(t1) {
                            if ("string" == typeof t1 || null === t1) return (0, N.U)(e1, "application.version", t1, k.nb, !1);
                            (0, l.R)(42, typeof t1);
                        }, e1);
                    }(this), function(e1) {
                        (0, N.Y)("start", function() {
                            e1.ee.emit("manual-start-all");
                        }, e1);
                    }(this), function(e1) {
                        (0, N.Y)(k.Pv, function(t1 = !0) {
                            if ("boolean" == typeof t1) {
                                if ((0, S.p)("api-" + k.Pv, [
                                    t1
                                ], void 0, "session", e1.ee), e1.runtime.consented = t1, t1) {
                                    const t1 = e1.features.page_view_event;
                                    t1.onAggregateImported.then((e1)=>{
                                        const r = t1.featAggregate;
                                        e1 && !r.sentRum && r.sendRum?.();
                                    });
                                }
                            } else (0, l.R)(65, typeof t1);
                        }, e1);
                    }(this), this.run()) : (0, l.R)(21);
                }
                get config() {
                    return {
                        info: this.info,
                        init: this.init,
                        loader_config: this.loader_config,
                        runtime: this.runtime
                    };
                }
                get api() {
                    return this;
                }
                run() {
                    try {
                        const e1 = function(e1) {
                            const t1 = {};
                            return n.forEach((r)=>{
                                t1[r] = !!e1[r]?.enabled;
                            }), t1;
                        }(this.init), r = [
                            ...this.desiredFeatures
                        ], i = this.init.feature_flags.includes("rum_v2");
                        r.sort((e1, r)=>t1.P3[e1.featureName] - t1.P3[r.featureName]), r.forEach((r)=>{
                            if (!e1[r.featureName] && (i || r.featureName !== t1.K7.pageViewEvent)) return;
                            const n = (function(e1) {
                                switch(e1){
                                    case t1.K7.ajax:
                                        return [
                                            t1.K7.jserrors
                                        ];
                                    case t1.K7.sessionTrace:
                                        return [
                                            t1.K7.ajax,
                                            t1.K7.pageViewEvent
                                        ];
                                    case t1.K7.sessionReplay:
                                        return [
                                            t1.K7.sessionTrace
                                        ];
                                    case t1.K7.pageViewTiming:
                                        return [
                                            t1.K7.pageViewEvent
                                        ];
                                    default:
                                        return [];
                                }
                            })(r.featureName).filter((e1)=>!(e1 in this.features));
                            n.length > 0 && (0, l.R)(36, {
                                targetFeature: r.featureName,
                                missingDependencies: n
                            }), this.features[r.featureName] = new r(this);
                        });
                    } catch (e1) {
                        (0, l.R)(22, e1);
                        for(const e1 in this.features)this.features[e1].abortHandler?.();
                        const t1 = (0, i.Zm)();
                        delete t1.initializedAgents[this.agentIdentifier]?.features, delete this.sharedAggregator;
                        return t1.ee.get(this.agentIdentifier).abort(), !1;
                    }
                }
            }
            var V = r(2843), z = r(782);
            class G extends W {
                static featureName = z.T;
                constructor(e1){
                    super(e1, z.T), g.RI && ((0, V.u)(()=>(0, S.p)("docHidden", [
                            (0, _.t)()
                        ], void 0, z.T, this.ee), !0), (0, V.G)(()=>(0, S.p)("winPagehide", [
                            (0, _.t)()
                        ], void 0, z.T, this.ee)), this.importAggregator(e1, ()=>r.e(478).then(r.bind(r, 9917))));
                }
            }
            var q = r(3969);
            class Y extends W {
                static featureName = q.TZ;
                constructor(e1){
                    super(e1, q.TZ), this.importAggregator(e1, ()=>r.e(478).then(r.bind(r, 6555)));
                }
            }
            var Z = r(6774), J = r(3878), X = r(3304);
            class Q {
                constructor(e1, t1, r, n, i){
                    this.name = "UncaughtError", this.message = "string" == typeof e1 ? e1 : (0, X.A)(e1), this.sourceURL = t1, this.line = r, this.column = n, this.__newrelic = i;
                }
            }
            function ee(e1) {
                return ne(e1) ? e1 : new Q(void 0 !== e1?.message ? e1.message : e1, e1?.filename || e1?.sourceURL, e1?.lineno || e1?.line, e1?.colno || e1?.col, e1?.__newrelic, e1?.cause);
            }
            function te(e1) {
                const t1 = "Unhandled Promise Rejection: ";
                if (!e1?.reason) return;
                if (ne(e1.reason)) {
                    try {
                        e1.reason.message.startsWith(t1) || (e1.reason.message = t1 + e1.reason.message);
                    } catch (e1) {}
                    return ee(e1.reason);
                }
                const r = ee(e1.reason);
                return (r.message || "").startsWith(t1) || (r.message = t1 + r.message), r;
            }
            function re(e1) {
                if (e1.error instanceof SyntaxError && !/:\d+$/.test(e1.error.stack?.trim())) {
                    const t1 = new Q(e1.message, e1.filename, e1.lineno, e1.colno, e1.error.__newrelic, e1.cause);
                    return t1.name = SyntaxError.name, t1;
                }
                return ne(e1.error) ? e1.error : ee(e1);
            }
            function ne(e1) {
                return e1 instanceof Error && !!e1.stack;
            }
            function ie(e1, r, n, i, s = (0, _.t)()) {
                "string" == typeof e1 && (e1 = new Error(e1)), (0, S.p)("err", [
                    e1,
                    s,
                    !1,
                    r,
                    n.runtime.isRecording,
                    void 0,
                    i
                ], void 0, t1.K7.jserrors, n.ee), (0, S.p)("uaErr", [], void 0, t1.K7.genericEvents, n.ee);
            }
            var se = r(993), ae = r(3785);
            function oe(e1, { customAttributes: t1 = {}, level: r = se.p_.INFO } = {}, n, i, s = (0, _.t)()) {
                (0, ae.R)(n.ee, e1, t1, r, !1, i, s);
            }
            function ce(e1, r, n, i, s = (0, _.t)()) {
                (0, S.p)("api-" + k.hG, [
                    s,
                    e1,
                    r,
                    i
                ], void 0, t1.K7.genericEvents, n.ee);
            }
            function de(e1, r, n, i, s = (0, _.t)()) {
                const { start: a, end: o, customAttributes: c } = r || {}, d = {
                    customAttributes: c || {}
                };
                if ("object" != typeof d.customAttributes || "string" != typeof e1 || 0 === e1.length) return void (0, l.R)(57);
                const u = (e1, t1)=>null == e1 ? t1 : "number" == typeof e1 ? e1 : e1 instanceof PerformanceMark ? e1.startTime : Number.NaN;
                if (d.start = u(a, 0), d.end = u(o, s), Number.isNaN(d.start) || Number.isNaN(d.end)) (0, l.R)(57);
                else {
                    if (d.duration = d.end - d.start, !(d.duration < 0)) return (0, S.p)("api-" + k.V1, [
                        d,
                        e1,
                        i
                    ], void 0, t1.K7.genericEvents, n.ee), d;
                    (0, l.R)(58);
                }
            }
            function ue(e1, r = {}, n, i, s = (0, _.t)()) {
                (0, S.p)("api-" + k.fF, [
                    s,
                    e1,
                    r,
                    i
                ], void 0, t1.K7.genericEvents, n.ee);
            }
            var le = r(5718);
            const fe = (e1, t1)=>e1?.nrMfeId === t1.id && (!e1?.nrMfeObserved || e1?.nrMfeObserved === t1.instance), he = (e1)=>{
                try {
                    return g.gm.CSS.escape(e1);
                } catch (t1) {
                    return e1;
                }
            }, pe = (e1, t1 = {})=>{
                const r = t1.id, n = t1.instance;
                if (!e1 || !r || !n) return !1;
                try {
                    let r = 1 === e1.nodeType ? e1 : e1.parentElement;
                    for(; r?.tagName;){
                        if (fe(r.dataset, t1)) return r.dataset.nrMfeObserved = n, !0;
                        r = r.parentNode;
                    }
                } catch (e1) {}
                return !1;
            }, ge = (e1, t1)=>{
                const r = g.gm.document?.querySelectorAll('[data-nr-mfe-id="'.concat(he(e1.id), '"]')), n = (Array.from(r) || []).find((t1)=>fe(t1.dataset, e1));
                let i = !!n;
                i && (n.dataset.nrMfeObserved ??= e1.instance);
                const s = new g.gm.MutationObserver((r)=>{
                    r.forEach((r)=>{
                        r.addedNodes.forEach((r)=>{
                            const n = 1 === r.nodeType ? r : null;
                            !i && fe(n?.dataset, e1) && (s.disconnect(), s.observe(n, {
                                childList: !0,
                                subtree: !0
                            }), i = !0, n.dataset.nrMfeObserved = e1.instance), ((e1)=>{
                                try {
                                    return e1?.textContent?.trim() || [
                                        "img",
                                        "video",
                                        "canvas",
                                        "svg"
                                    ].includes(e1?.nodeName?.toLowerCase());
                                } catch (e1) {
                                    return !1;
                                }
                            })(r) && (i || pe(r, e1)) && t1(r, s);
                        });
                    });
                });
                return s.observe(n || g.gm.document, {
                    childList: !0,
                    subtree: !0
                }), s;
            }, me = (e1, t1, r)=>{
                try {
                    const n = new g.gm.PerformanceObserver((e1)=>{
                        e1.getEntries().forEach(r);
                    });
                    return n.observe(t1), e1.push(n), n;
                } catch (e1) {
                    return null;
                }
            };
            function ve(e1, t1) {
                let r, n, i = !1;
                const s = (e1)=>null == e1 ? e1 : e1 - (t1?.scriptStart || t1?.registeredAt || 0), a = {
                    fcp: {
                        get value () {
                            const e1 = s(r);
                            return e1 > 1e4 ? void 0 : e1;
                        },
                        set value (e){
                            i || (r = e);
                        }
                    },
                    lcp: {
                        get value () {
                            if (void 0 !== a.fcp.value) return s(n);
                        },
                        set value (e){
                            i || (n = e);
                        }
                    },
                    cls: {
                        value: void 0
                    },
                    inp: {
                        value: void 0
                    },
                    disconnect: ()=>{}
                };
                if (!(e1 && g.RI && g.gm.MutationObserver && g.gm.PerformanceObserver)) return a;
                const o = [];
                setTimeout(()=>{
                    r || a.disconnect();
                }, 1e4);
                const c = ()=>{
                    if (!i) {
                        if (null == r) {
                            const e1 = (0, _.t)();
                            if (s(e1) > 1e4) return void a.disconnect();
                            r = e1;
                        }
                        n ??= (0, _.t)(), a.cls.value ??= 0;
                    }
                }, d = ge(e1, (e1, t1)=>{
                    c(), t1.disconnect();
                });
                o.push(d);
                let u = 0, l = null;
                const f = new Set;
                try {
                    l = new g.gm.ResizeObserver((e1)=>{
                        i || e1.forEach((e1)=>{
                            try {
                                const t1 = e1.contentRect.width * e1.contentRect.height;
                                t1 > u && (u = t1, a.lcp.value = (0, _.t)()), l.unobserve(e1.target);
                            } catch (e1) {}
                        });
                    });
                } catch (e1) {}
                const h = ge(e1, (e1)=>{
                    if (c(), l) try {
                        const t1 = 1 === e1.nodeType ? e1 : e1.parentElement;
                        t1 && !f.has(t1) && (f.add(t1), "IMG" === t1.tagName ? t1.complete ? l.observe(t1) : t1.addEventListener("load", ()=>{
                            l.observe(t1);
                        }, {
                            once: !0
                        }) : "VIDEO" === t1.tagName ? t1.readyState >= 2 ? l.observe(t1) : t1.addEventListener("loadeddata", ()=>{
                            l.observe(t1);
                        }, {
                            once: !0
                        }) : l.observe(t1));
                    } catch (e1) {}
                });
                l && o.push(l), o.push(h), me(o, {
                    type: "layout-shift",
                    buffered: !0
                }, (t1)=>{
                    i || t1.hadRecentInput || (t1.sources || []).some((r)=>!!pe(r.node, e1) && (c(), a.cls.value += t1.value, !0));
                }), me(o, {
                    type: "event",
                    buffered: !0,
                    durationThreshold: 40
                }, (t1)=>{
                    !i && t1.interactionId && pe(t1.target, e1) && (void 0 === a.inp.value || t1.duration > a.inp.value) && (c(), a.inp.value = t1.duration);
                });
                const p = [
                    "pointerdown",
                    "keydown"
                ], m = ()=>{
                    p.forEach((e1)=>{
                        g.gm.removeEventListener(e1, v, {
                            passive: !0
                        });
                    });
                };
                a.disconnect = ()=>{
                    i = !0, o.forEach((e1)=>{
                        try {
                            e1?.disconnect();
                        } catch (e1) {}
                    }), m(), [
                        "visibilitychange",
                        "pagehide"
                    ].forEach((e1)=>{
                        g.gm.removeEventListener(e1, a.disconnect, {
                            once: !0,
                            passive: !0
                        });
                    });
                };
                const v = (t1)=>{
                    pe(t1?.target, e1) && ((()=>{
                        try {
                            h?.disconnect(), l?.disconnect();
                        } catch (e1) {}
                    })(), m());
                };
                p.forEach((e1)=>{
                    g.gm.addEventListener(e1, v, {
                        passive: !0
                    });
                }), [
                    "visibilitychange",
                    "pagehide"
                ].forEach((e1)=>{
                    g.gm.addEventListener(e1, a.disconnect, {
                        once: !0,
                        passive: !0
                    });
                });
                const y = g.gm.document?.querySelectorAll('[data-nr-mfe-id="'.concat(he(e1.id), '"]'));
                return Array.from(y || []).some((t1)=>fe(t1.dataset, e1)) && c(), a;
            }
            var ye = r(9566), be = r(7560), Ee = r(9119);
            const we = [
                "entry",
                "scripts",
                "all"
            ], Re = [
                "name",
                "id",
                "type"
            ], Te = new Map([
                [
                    ce,
                    "addPageAction"
                ],
                [
                    oe,
                    "log"
                ],
                [
                    de,
                    "measure"
                ],
                [
                    ie,
                    "noticeError"
                ],
                [
                    ue,
                    "recordCustomEvent"
                ]
            ]), Ae = {
                experimental: (0, C.J)(()=>(0, l.R)(54, "newrelic.register")),
                disabled: (0, C.J)(()=>(0, l.R)(55)),
                invalidTarget: (0, C.J)((e1)=>(0, l.R)(48, e1)),
                deregistered: (0, C.J)(()=>(0, l.R)(68)),
                invalidTimingMethod: (0, C.J)((e1)=>(0, l.R)(80, e1)),
                duplicateName: (0, C.J)((e1)=>(0, l.R)(81, e1)),
                duplicateId: (0, C.J)((e1)=>(0, l.R)(82, e1))
            };
            function Se(e1) {
                (0, N.Y)(k.eY, function(t1) {
                    return xe(e1, t1);
                }, e1);
            }
            function xe(e1, r) {
                Ae.experimental(), r ||= {}, r.instance = (0, ye.LA)(8), r.type = w.f.MFE, r.licenseKey ||= e1.info.licenseKey, r.blocked = !1, ("object" != typeof r.tags || null === r.tags || Array.isArray(r.tags)) && (r.tags = {}), r.parent ??= {
                    get id () {
                        return e1.runtime.appMetadata.agents?.[0].entityGuid;
                    },
                    type: w.f.BA
                }, r.manifest = (0, be.N)(r.manifest), void 0 === r.timingMethod || we.includes(r.timingMethod) || (Ae.invalidTimingMethod(r.timingMethod), r.timingMethod = void 0);
                const n = (0, le.Qr)(r);
                r.manifest && (0, le.xo)(n, r);
                const i = ve(r, n), s = (0, Ee.L)("" + location), a = {};
                Object.prototype.hasOwnProperty.call(r, "attributes") || Object.defineProperty(r, "attributes", {
                    get: ()=>({
                            ...a,
                            "source.id": r.id,
                            "source.name": r.name,
                            "source.type": r.type,
                            "parent.type": r.parent?.type || w.f.BA,
                            "parent.id": r.parent?.id
                        })
                }), Object.entries(r.tags).forEach(([e1, t1])=>{
                    Re.includes(e1) || (a["source.".concat(e1)] = t1);
                });
                let o = ()=>{};
                const c = e1.runtime.registeredEntities, d = (e1)=>{
                    r.blocked = !0, o = e1;
                };
                function u(e1) {
                    return "string" == typeof e1 && !!e1.trim() && e1.trim().length < 501;
                }
                e1.init.api.register.enabled || d(Ae.disabled), u(r.id) && u(r.name) || d(()=>Ae.invalidTarget(r)), c.forEach((e1)=>{
                    try {
                        const { name: t1, id: n } = e1.metadata.target;
                        t1 === r.name && n !== r.id && Ae.duplicateName(r), n === r.id && t1 !== r.name && Ae.duplicateId(r);
                    } catch (e1) {}
                });
                const f = {
                    addPageAction: (t1, n = {})=>m(ce, [
                            t1,
                            {
                                ...a,
                                ...n
                            },
                            e1
                        ], r),
                    deregister: ()=>{
                        p(), d(Ae.deregistered);
                    },
                    log: (t1, n = {})=>m(oe, [
                            t1,
                            {
                                ...n,
                                customAttributes: {
                                    ...a,
                                    ...n.customAttributes || {}
                                }
                            },
                            e1
                        ], r),
                    measure: (t1, n = {})=>m(de, [
                            t1,
                            {
                                ...n,
                                customAttributes: {
                                    ...a,
                                    ...n.customAttributes || {}
                                }
                            },
                            e1
                        ], r),
                    noticeError: (t1, n = {})=>m(ie, [
                            t1,
                            {
                                ...a,
                                ...n
                            },
                            e1
                        ], r),
                    recordCustomEvent: (t1, n = {})=>m(ue, [
                            t1,
                            {
                                ...a,
                                ...n
                            },
                            e1
                        ], r),
                    setApplicationVersion: (e1)=>g("application.version", e1),
                    setCustomAttribute: (e1, t1)=>g(e1, t1),
                    setUserId: (e1)=>g("enduser.id", e1),
                    metadata: {
                        get customAttributes () {
                            return a;
                        },
                        target: r,
                        timings: n,
                        vitals: i,
                        events: {
                            latestTimestamp: void 0
                        }
                    }
                }, h = ()=>(r.blocked && o(), r.blocked);
                function p() {
                    if (n.reportedAt) return;
                    n.reportedAt = (0, _.t)(), i.disconnect(), n.fcp = i.fcp, n.lcp = i.lcp, n.cls = i.cls, n.inp = i.inp;
                    const e1 = n.fetchEnd - n.fetchStart, t1 = n.scriptEnd - n.scriptStart, r = {
                        assetUrl: n.asset,
                        assetType: n.type,
                        registerUrl: s,
                        deregisterUrl: (0, Ee.L)("" + location),
                        pageUrl: void 0,
                        currentUrl: void 0,
                        timeAlive: n.reportedAt - n.registeredAt,
                        timeToBeRequested: n.fetchStart,
                        timeToExecute: t1,
                        timeToFetch: e1,
                        timeToLoad: e1 + t1,
                        timeToRegister: n.registeredAt,
                        totalWeight: n.totalWeight,
                        ...void 0 !== n.renderBlocking && {
                            renderBlocking: n.renderBlocking
                        },
                        ...i.fcp.value >= 0 && {
                            "vitals.fcp.value": i.fcp.value
                        },
                        ...i.lcp.value >= 0 && {
                            "vitals.lcp.value": i.lcp.value
                        },
                        ...i.cls.value >= 0 && {
                            "vitals.cls.value": i.cls.value
                        },
                        ...i.inp.value >= 0 && {
                            "vitals.inp.value": i.inp.value
                        }
                    };
                    f.recordCustomEvent("MicroFrontEndTiming", r);
                }
                h() || (c.push(f), (0, V.G)(p));
                const g = (e1, t1)=>{
                    h() || (a[e1] = t1);
                }, m = (r, n, i)=>{
                    if (h() && r !== xe) return;
                    const s = f.metadata.events.latestTimestamp ?? (0, _.t)();
                    f.metadata.events.latestTimestamp = void 0;
                    const a = Te.get(r) || "unknown";
                    (0, S.p)(q.xV, [
                        "API/register/".concat(a, "/called")
                    ], void 0, t1.K7.metrics, e1.ee);
                    try {
                        return r(...n, i, s);
                    } catch (e1) {
                        (0, l.R)(50, e1);
                    }
                };
                return f;
            }
            class Oe extends W {
                static featureName = Z.T;
                constructor(e1){
                    var t1;
                    super(e1, Z.T), t1 = e1, (0, N.Y)(k.o5, (e1, r)=>ie(e1, r, t1), t1), function(e1) {
                        (0, N.Y)(k.bt, function(t1) {
                            e1.runtime.onerror = t1;
                        }, e1);
                    }(e1), function(e1) {
                        let t1 = 0;
                        (0, N.Y)(k.k6, function(e1, r) {
                            ++t1 > 10 || (this.runtime.releaseIds[e1.slice(-200)] = ("" + r).slice(-200));
                        }, e1);
                    }(e1), Se(e1);
                    try {
                        this.removeOnAbort = new AbortController;
                    } catch (e1) {}
                    this.ee.on("internal-error", (t1, r)=>{
                        this.abortHandler && (0, S.p)("ierr", [
                            ee(t1),
                            (0, _.t)(),
                            !0,
                            {},
                            e1.runtime.isRecording,
                            r
                        ], void 0, this.featureName, this.ee);
                    }), g.gm.addEventListener("unhandledrejection", (t1)=>{
                        this.abortHandler && (0, S.p)("err", [
                            te(t1),
                            (0, _.t)(),
                            !1,
                            {
                                unhandledPromiseRejection: 1
                            },
                            e1.runtime.isRecording
                        ], void 0, this.featureName, this.ee);
                    }, (0, J.jT)(!1, this.removeOnAbort?.signal)), g.gm.addEventListener("error", (t1)=>{
                        this.abortHandler && (0, S.p)("err", [
                            re(t1),
                            (0, _.t)(),
                            !1,
                            {},
                            e1.runtime.isRecording
                        ], void 0, this.featureName, this.ee);
                    }, (0, J.jT)(!1, this.removeOnAbort?.signal)), this.abortHandler = this.#n, this.importAggregator(e1, ()=>r.e(478).then(r.bind(r, 9377)));
                }
                #n() {
                    this.removeOnAbort?.abort(), this.abortHandler = void 0;
                }
            }
            var _e = r(8990);
            let ke = 1;
            function Ne(e1) {
                const t1 = typeof e1;
                return !e1 || "object" !== t1 && "function" !== t1 ? -1 : e1 === g.gm ? 0 : (0, _e.I)(e1, "nr@id", function() {
                    return ke++;
                });
            }
            function Le(e1) {
                if ("string" == typeof e1) return e1.length;
                if ("object" == typeof e1) {
                    if ("undefined" != typeof ArrayBuffer && e1 instanceof ArrayBuffer && e1.byteLength) return e1.byteLength;
                    if ("undefined" != typeof Blob && e1 instanceof Blob && e1.size) return e1.size;
                    if (!("undefined" != typeof FormData && e1 instanceof FormData)) try {
                        return (0, X.A)(e1).length;
                    } catch (e1) {
                        return;
                    }
                }
            }
            var Me = r(8139), Pe = r(3434), Ie = r(5732);
            const je = {}, Ce = [
                "open",
                "send",
                "setRequestHeader"
            ];
            function De(e1, t1) {
                var r = e1 || R.ee;
                const n = function(e1) {
                    return (e1 || R.ee).get("xhr");
                }(r);
                if (void 0 === g.gm.XMLHttpRequest) return n;
                if (je[n.debugId]++) return n;
                je[n.debugId] = 1, (0, Me.u)(r, t1);
                var i = (0, Pe.YM)(n, void 0, t1), s = g.gm.XMLHttpRequest, a = g.gm.MutationObserver, o = g.gm.Promise, c = g.gm.setInterval, d = "readystatechange", u = [
                    "onload",
                    "onerror",
                    "onabort",
                    "onloadstart",
                    "onloadend",
                    "onprogress",
                    "ontimeout"
                ], f = [], h = g.gm.XMLHttpRequest = function(e1) {
                    const r = new s(e1), a = n.context(r);
                    a.targets = (0, Ie.$5)(t1);
                    try {
                        n.emit("new-xhr", [
                            r
                        ], a), r.addEventListener(d, (o = a, function() {
                            var e1 = this;
                            e1.readyState > 3 && !o.resolved && (o.resolved = !0, n.emit("xhr-resolved", [], e1)), i.inPlace(e1, u, "fn-", E);
                        }), (0, J.jT)(!1));
                    } catch (e1) {
                        (0, l.R)(15, e1);
                        try {
                            n.emit("internal-error", [
                                e1
                            ]);
                        } catch (e1) {}
                    }
                    var o;
                    return r;
                };
                function p(e1, t1) {
                    i.inPlace(t1, [
                        "onreadystatechange"
                    ], "fn-", E);
                }
                if (function(e1, t1) {
                    for(var r in e1)t1[r] = e1[r];
                }(s, h), h.prototype = s.prototype, i.inPlace(h.prototype, Ce, "-xhr-", E), n.on("send-xhr-start", function(e1, t1) {
                    p(e1, t1), function(e1) {
                        f.push(e1), a && (m ? m.then(b) : c ? c(b) : (v = -v, y.data = v));
                    }(t1);
                }), n.on("open-xhr-start", p), a) {
                    var m = o && o.resolve();
                    if (!c && !o) {
                        var v = 1, y = document.createTextNode(v);
                        new a(b).observe(y, {
                            characterData: !0
                        });
                    }
                } else r.on("fn-end", function(e1) {
                    e1[0] && e1[0].type === d || b();
                });
                function b() {
                    for(var e1 = 0; e1 < f.length; e1++)p(0, f[e1]);
                    f.length && (f = []);
                }
                function E(e1, t1) {
                    return t1;
                }
                return n;
            }
            var Be = "fetch-", He = Be + "body-", We = [
                "arrayBuffer",
                "blob",
                "json",
                "text",
                "formData"
            ], Ue = g.gm.Request, Ke = g.gm.Response, Fe = "prototype";
            const Ve = {};
            function ze(e1, t1) {
                const r = function(e1) {
                    return (e1 || R.ee).get("fetch");
                }(e1);
                if (!(Ue && Ke && g.gm.fetch)) return r;
                if (Ve[r.debugId]++) return r;
                function n(e1, n, i) {
                    var s = e1[n];
                    "function" == typeof s && (e1[n] = function() {
                        var e1 = [
                            ...arguments
                        ];
                        const n = {}, a = (0, Ie.$5)(t1);
                        var o;
                        r.emit(i + "before-start", [
                            e1
                        ], n), n[R.P] && n[R.P].dt && (o = n[R.P].dt);
                        var c = s.apply(this, e1);
                        return r.emit(i + "start", [
                            e1,
                            o
                        ], c), c.then(function(e1) {
                            return r.emit(i + "end", [
                                null,
                                e1,
                                a
                            ], c), e1;
                        }, function(e1) {
                            throw r.emit(i + "end", [
                                e1,
                                void 0,
                                a
                            ], c), e1;
                        });
                    });
                }
                return Ve[r.debugId] = 1, We.forEach((e1)=>{
                    n(Ue[Fe], e1, He), n(Ke[Fe], e1, He);
                }), n(g.gm, "fetch", Be), r.on(Be + "end", function(e1, n, i) {
                    var s = this;
                    if (s.targets = i || [
                        t1.runtime.v2Target
                    ], n) {
                        var a = n.headers.get("content-length");
                        null !== a && (s.rxSize = a), r.emit(Be + "done", [
                            null,
                            n
                        ], s);
                    } else r.emit(Be + "done", [
                        e1
                    ], s);
                }), r;
            }
            var Ge = r(7485);
            class qe {
                constructor(e1){
                    this.agentRef = e1;
                }
                generateTracePayload(e1) {
                    const t1 = this.agentRef.loader_config;
                    if (!this.shouldGenerateTrace(e1) || !t1) return null;
                    var r = (t1.accountID || "").toString() || null, n = (t1.agentID || "").toString() || null, i = (t1.trustKey || "").toString() || null;
                    if (!r || !n) return null;
                    var s, a = (0, ye.ZF)(), o = (0, ye.el)(), c = Date.now();
                    this.agentRef.runtime?.timeKeeper?.ready && (s = Math.floor(this.agentRef.runtime.timeKeeper.correctAbsoluteTimestamp(c)));
                    var d = {
                        spanId: a,
                        traceId: o,
                        timestamp: c,
                        timestampCorrected: s
                    };
                    return (e1.sameOrigin || this.isAllowedOrigin(e1) && this.useTraceContextHeadersForCors()) && (d.traceContextParentHeader = this.generateTraceContextParentHeader(a, o), d.traceContextStateHeader = this.generateTraceContextStateHeader(a, s ?? c, r, n, i)), (e1.sameOrigin && !this.excludeNewrelicHeader() || !e1.sameOrigin && this.isAllowedOrigin(e1) && this.useNewrelicHeaderForCors()) && (d.newrelicHeader = this.generateTraceHeader(a, o, s ?? c, r, n, i)), d;
                }
                generateTraceContextParentHeader(e1, t1) {
                    return "00-" + t1 + "-" + e1 + "-01";
                }
                generateTraceContextStateHeader(e1, t1, r, n, i) {
                    return i + "@nr=0-1-" + r + "-" + n + "-" + e1 + "----" + t1;
                }
                generateTraceHeader(e1, t1, r, n, i, s) {
                    if (!("function" == typeof g.gm?.btoa)) return null;
                    var a = {
                        v: [
                            0,
                            1
                        ],
                        d: {
                            ty: "Browser",
                            ac: n,
                            ap: i,
                            id: e1,
                            tr: t1,
                            ti: r
                        }
                    };
                    return s && n !== s && (a.d.tk = s), btoa((0, X.A)(a));
                }
                shouldGenerateTrace(e1) {
                    return this.agentRef.init?.distributed_tracing?.enabled && this.isAllowedOrigin(e1);
                }
                isAllowedOrigin(e1) {
                    var t1 = !1;
                    const r = this.agentRef.init?.distributed_tracing;
                    if (e1.sameOrigin) t1 = !0;
                    else if (r?.allowed_origins instanceof Array) for(var n = 0; n < r.allowed_origins.length; n++){
                        var i = (0, Ge.D)(r.allowed_origins[n]);
                        if (e1.hostname === i.hostname && e1.protocol === i.protocol && e1.port === i.port) {
                            t1 = !0;
                            break;
                        }
                    }
                    return t1;
                }
                excludeNewrelicHeader() {
                    var e1 = this.agentRef.init?.distributed_tracing;
                    return !!e1 && !!e1.exclude_newrelic_header;
                }
                useNewrelicHeaderForCors() {
                    var e1 = this.agentRef.init?.distributed_tracing;
                    return !!e1 && !1 !== e1.cors_use_newrelic_header;
                }
                useTraceContextHeadersForCors() {
                    var e1 = this.agentRef.init?.distributed_tracing;
                    return !!e1 && !!e1.cors_use_tracecontext_headers;
                }
            }
            var Ye = r(7295);
            function Ze(e1) {
                return "string" == typeof e1 ? e1 : e1 instanceof (0, i.dV)().o.REQ ? e1.url : g.gm?.URL && e1 instanceof URL ? e1.href : void 0;
            }
            function $e(e1, t1) {
                var r = (0, Ge.D)(t1), n = e1.params || e1;
                n.hostname = r.hostname, n.port = r.port, n.protocol = r.protocol, n.host = r.hostname + ":" + r.port, n.pathname = r.pathname, e1.parsedOrigin = r, e1.sameOrigin = r.sameOrigin;
            }
            var Je = [
                "load",
                "error",
                "abort",
                "timeout"
            ], Xe = Je.length, Qe = (0, i.dV)().o.REQ, et = (0, i.dV)().o.XHR;
            const tt = "X-NewRelic-App-Data", rt = "internal-error";
            class nt extends W {
                static featureName = c.TZ;
                constructor(e1){
                    super(e1, c.TZ), this.dt = new qe(e1), this.handler = (e1, t1, r, n)=>(0, S.p)(e1, t1, r, n, this.ee);
                    try {
                        const e1 = {
                            xmlhttprequest: "xhr",
                            fetch: "fetch",
                            beacon: "beacon"
                        };
                        g.gm?.performance?.getEntriesByType("resource").forEach((r)=>{
                            if (r.initiatorType in e1 && 0 !== r.responseStatus) {
                                const n = {
                                    status: r.responseStatus
                                }, i = {
                                    rxSize: r.transferSize,
                                    duration: Math.floor(r.duration),
                                    cbTime: 0
                                };
                                $e(n, r.name), this.handler("xhr", [
                                    n,
                                    i,
                                    r.startTime,
                                    r.responseEnd,
                                    e1[r.initiatorType]
                                ], void 0, t1.K7.ajax);
                            }
                        });
                    } catch (e1) {}
                    ze(this.ee, e1), De(this.ee, e1), function(e1, r, n, i) {
                        const s = [
                            c.mo.ALL,
                            c.mo.FAILURES
                        ].includes(e1.init.ajax?.capture_payloads);
                        function a(e1) {
                            var t1 = this;
                            t1.totalCbs = 0, t1.called = 0, t1.cbTime = 0, t1.end = A, t1.ended = !1, t1.xhrGuids = {}, t1.lastSize = null, t1.loadCaptureCalled = !1, t1.params = this.params || {}, t1.metrics = this.metrics || {}, t1.latestLongtaskEnd = 0, e1.addEventListener("load", function(r) {
                                O(t1, e1);
                            }, (0, J.jT)(!1)), g.lR || e1.addEventListener("progress", function(e1) {
                                t1.lastSize = e1.loaded;
                            }, (0, J.jT)(!1));
                        }
                        function o(e1) {
                            this.params = {
                                method: e1[0]
                            }, $e(this, e1[1]), this.metrics = {};
                        }
                        function d(t1, r) {
                            e1.loader_config.xpid && this.sameOrigin && r.setRequestHeader("X-NewRelic-ID", e1.loader_config.xpid);
                            var n = i.generateTracePayload(this.parsedOrigin);
                            if (n) {
                                var s = !1;
                                n.newrelicHeader && (r.setRequestHeader("newrelic", n.newrelicHeader), s = !0), n.traceContextParentHeader && (r.setRequestHeader("traceparent", n.traceContextParentHeader), n.traceContextStateHeader && r.setRequestHeader("tracestate", n.traceContextStateHeader), s = !0), s && (this.dt = n);
                            }
                        }
                        function u(e1, t1) {
                            s && e1.length >= 2 && (this.requestHeaders ??= {}, this.requestHeaders[e1[0].toLowerCase()] = e1[1]);
                        }
                        function l(e1, t1) {
                            var n = this.metrics, i = e1[0], s = this;
                            if (n && i) {
                                var a = Le(i);
                                a && (n.txSize = a);
                            }
                            this.startTime = (0, _.t)(), this.requestBody = i, this.listener = function(e1) {
                                try {
                                    "abort" !== e1.type || s.loadCaptureCalled || (s.params.aborted = !0), ("load" !== e1.type || s.called === s.totalCbs && (s.onloadCalled || "function" != typeof t1.onload) && "function" == typeof s.end) && s.end(t1);
                                } catch (e1) {
                                    try {
                                        r.emit(rt, [
                                            e1
                                        ]);
                                    } catch (e1) {}
                                }
                            };
                            for(var o = 0; o < Xe; o++)t1.addEventListener(Je[o], this.listener, (0, J.jT)(!1));
                        }
                        function f(e1, t1, r) {
                            this.cbTime += e1, t1 ? this.onloadCalled = !0 : this.called += 1, this.called !== this.totalCbs || !this.onloadCalled && "function" == typeof r.onload || "function" != typeof this.end || this.end(r);
                        }
                        function h(e1, t1) {
                            var r = "" + Ne(e1) + !!t1;
                            this.xhrGuids && !this.xhrGuids[r] && (this.xhrGuids[r] = !0, this.totalCbs += 1);
                        }
                        function p(e1, t1) {
                            var r = "" + Ne(e1) + !!t1;
                            this.xhrGuids && this.xhrGuids[r] && (delete this.xhrGuids[r], this.totalCbs -= 1);
                        }
                        function m() {
                            this.endTime = (0, _.t)();
                        }
                        function v(e1, t1) {
                            t1 instanceof et && "load" === e1[0] && r.emit("xhr-load-added", [
                                e1[1],
                                e1[2]
                            ], t1);
                        }
                        function y(e1, t1) {
                            t1 instanceof et && "load" === e1[0] && r.emit("xhr-load-removed", [
                                e1[1],
                                e1[2]
                            ], t1);
                        }
                        function b(e1, t1, r) {
                            t1 instanceof et && ("onload" === r && (this.onload = !0), ("load" === (e1[0] && e1[0].type) || this.onload) && (this.xhrCbStart = (0, _.t)()));
                        }
                        function E(e1, t1) {
                            this.xhrCbStart && r.emit("xhr-cb-time", [
                                (0, _.t)() - this.xhrCbStart,
                                this.onload,
                                t1
                            ], t1);
                        }
                        function w(e1) {
                            var t1, r = e1[1] || {};
                            if ("string" == typeof e1[0] ? 0 === (t1 = e1[0]).length && g.RI && (t1 = "" + g.gm.location.href) : e1[0] && e1[0].url ? t1 = e1[0].url : g.gm?.URL && e1[0] && e1[0] instanceof URL ? t1 = e1[0].href : "function" == typeof e1[0].toString && (t1 = e1[0].toString()), "string" == typeof t1 && 0 !== t1.length) {
                                t1 && (this.parsedOrigin = (0, Ge.D)(t1), this.sameOrigin = this.parsedOrigin.sameOrigin);
                                var n = i.generateTracePayload(this.parsedOrigin);
                                if (n && (n.newrelicHeader || n.traceContextParentHeader)) {
                                    if (e1[0] && e1[0].headers) o(e1[0].headers, n) && (this.dt = n);
                                    else {
                                        var s = {};
                                        for(var a in r)s[a] = r[a];
                                        s.headers = new Headers(r.headers || {}), o(s.headers, n) && (this.dt = n), e1.length > 1 ? e1[1] = s : e1.push(s);
                                    }
                                }
                            }
                            function o(e1, t1) {
                                var r = !1;
                                return t1.newrelicHeader && (e1.set("newrelic", t1.newrelicHeader), r = !0), t1.traceContextParentHeader && (e1.set("traceparent", t1.traceContextParentHeader), t1.traceContextStateHeader && e1.set("tracestate", t1.traceContextStateHeader), r = !0), r;
                            }
                        }
                        function R(e1, t1) {
                            this.params = {}, this.metrics = {}, this.startTime = (0, _.t)(), this.dt = t1;
                            let [r, n = {}] = e1;
                            $e(this, Ze(r));
                            const i = ("" + (r && r instanceof Qe && r.method || n.method || "GET")).toUpperCase();
                            this.params.method = i, this.txSize = Le(n.body || r?.body) || 0;
                            try {
                                var a = n.headers || r?.headers;
                                if (s && a) {
                                    if (this.requestHeaders ??= {}, a instanceof Headers) a.forEach((function(e1, t1) {
                                        this.requestHeaders[t1.toLowerCase()] = e1;
                                    }).bind(this));
                                    else if ("object" == typeof a) for(var o in a)this.requestHeaders[o.toLowerCase()] = a[o];
                                }
                            } catch (e1) {}
                            this.requestBody = n.body || r?.body;
                        }
                        function T(e1, t1) {
                            if (this.endTime = (0, _.t)(), this.params || (this.params = {}), (0, Ye.iW)(this.params)) return;
                            this.params.status = t1 ? t1.status : 0;
                            const n = ()=>{
                                const e1 = +this.rxSize, t1 = null == this.rxSize || isNaN(e1) ? void 0 : e1, r = {
                                    txSize: this.txSize,
                                    rxSize: t1,
                                    duration: this.endTime - this.startTime
                                }, n = [
                                    this.params,
                                    r,
                                    this.startTime,
                                    this.endTime,
                                    "fetch"
                                ];
                                this.targets.forEach((e1)=>x(n, this, e1));
                            };
                            t1 && s ? t1.clone().text().then((e1)=>{
                                this.responseBody = e1, this.rxSize && "0" !== this.rxSize && 0 !== this.rxSize || void 0 === e1 || 0 === this.params.status || (this.rxSize = Le(e1)), t1?.headers && (this.responseHeaders = {}, t1.headers.forEach((function(e1, t1) {
                                    this.responseHeaders[t1.toLowerCase()] = e1;
                                }).bind(this)));
                            }).catch((e1)=>{
                                r.emit(rt, [
                                    e1
                                ]);
                            }).finally(()=>{
                                n();
                            }) : n();
                        }
                        function A(e1) {
                            const t1 = this.params, n = this.metrics;
                            if (this.ended) return;
                            this.ended = !0;
                            for(let t1 = 0; t1 < Xe; t1++)e1.removeEventListener(Je[t1], this.listener, !1);
                            if (t1.aborted) return;
                            if ((0, Ye.iW)(t1)) return;
                            if (n.duration = this.endTime - this.startTime, this.loadCaptureCalled || 4 !== e1.readyState ? null == t1.status && (t1.status = 0) : O(this, e1), n.cbTime = this.cbTime, s) {
                                try {
                                    this.responseBody = e1.responseText;
                                } catch (t1) {
                                    this.responseBody = e1.response;
                                }
                                if ((!n.rxSize || 0 === n.rxSize) && void 0 !== this.responseBody && 0 !== t1.status) {
                                    const e1 = Le(this.responseBody);
                                    void 0 !== e1 && (n.rxSize = e1);
                                }
                                try {
                                    this.responseHeaders = function(e1) {
                                        const t1 = {};
                                        return e1 ? (e1.split("\r\n").forEach(function(e1) {
                                            const r = e1.indexOf(": ");
                                            if (r > 0) {
                                                const n = e1.substring(0, r), i = e1.substring(r + 2);
                                                t1[n.toLowerCase()] = i;
                                            }
                                        }), t1) : t1;
                                    }(e1.getAllResponseHeaders());
                                } catch (e1) {
                                    r.emit(rt, [
                                        e1
                                    ]);
                                }
                            }
                            const i = [
                                t1,
                                n,
                                this.startTime,
                                this.endTime,
                                "xhr"
                            ];
                            this.targets.forEach((e1)=>x(i, this, e1));
                        }
                        function x(e1, r, i) {
                            n("xhr", [
                                ...e1,
                                i
                            ], r, t1.K7.ajax);
                        }
                        function O(e1, n) {
                            e1.params.status = n.status;
                            var i = function(e1, t1) {
                                var r = e1.responseType;
                                return "json" === r && null !== t1 ? t1 : "arraybuffer" === r || "blob" === r || "json" === r ? Le(e1.response) : "text" === r || "" === r || void 0 === r ? Le(e1.responseText) : void 0;
                            }(n, e1.lastSize);
                            if (void 0 !== i && 0 !== n.status && (e1.metrics.rxSize = i), e1.sameOrigin && n.getAllResponseHeaders().indexOf(tt) >= 0) {
                                var s = n.getResponseHeader(tt);
                                s && ((0, S.p)("sm", [
                                    "Ajax/CrossApplicationTracing/Header/Seen"
                                ], void 0, t1.K7.metrics, r), e1.params.cat = s.split(", ").pop());
                            }
                            e1.loadCaptureCalled = !0;
                        }
                        r.on("new-xhr", a), r.on("open-xhr-start", o), r.on("open-xhr-end", d), r.on("send-xhr-start", l), r.on("setRequestHeader-xhr-start", u), r.on("xhr-cb-time", f), r.on("xhr-load-added", h), r.on("xhr-load-removed", p), r.on("xhr-resolved", m), r.on("addEventListener-end", v), r.on("removeEventListener-end", y), r.on("fn-end", E), r.on("fetch-before-start", w), r.on("fetch-start", R), r.on("fn-start", b), r.on("fetch-done", T);
                    }(e1, this.ee, this.handler, this.dt), this.importAggregator(e1, ()=>r.e(478).then(r.bind(r, 3845)));
                }
            }
            const it = {}, st = [
                "pushState",
                "replaceState"
            ];
            function at(e1, t1) {
                const r = function(e1) {
                    return (e1 || R.ee).get("history");
                }(e1);
                return !g.RI || it[r.debugId]++ || (it[r.debugId] = 1, (0, Pe.YM)(r, void 0, t1).inPlace(window.history, st, "-")), r;
            }
            var ot = r(3738);
            function ct(e1) {
                (0, N.Y)(k.BL, function(r = Date.now()) {
                    const n = r - g.WN;
                    n < 0 && (0, l.R)(62, r), (0, S.p)(q.XG, [
                        k.BL,
                        {
                            time: n
                        }
                    ], void 0, t1.K7.metrics, e1.ee), e1.addToTrace({
                        name: k.BL,
                        start: r,
                        origin: "nr"
                    }), (0, S.p)("api-" + k.hG, [
                        n,
                        k.BL
                    ], void 0, t1.K7.genericEvents, e1.ee);
                }, e1);
            }
            const { He: dt, bD: ut, d3: lt, Kp: ft, TZ: ht, Lc: pt, uP: gt, Rz: mt } = ot;
            class vt extends W {
                static featureName = ht;
                constructor(e1){
                    var n;
                    super(e1, ht), n = e1, (0, N.Y)(k.U2, function(e1) {
                        if (!(e1 && "object" == typeof e1 && e1.name && e1.start)) return;
                        const r = {
                            n: e1.name,
                            s: e1.start - g.WN,
                            e: (e1.end || e1.start) - g.WN,
                            o: e1.origin || "",
                            t: "api"
                        };
                        r.s < 0 || r.e < 0 || r.e < r.s ? (0, l.R)(61, {
                            start: r.s,
                            end: r.e
                        }) : (0, S.p)("bstApi", [
                            r
                        ], void 0, t1.K7.sessionTrace, n.ee);
                    }, n), ct(e1);
                    if (!(0, j.V)(e1.init)) return void this.deregisterDrain();
                    const i = this.ee;
                    let s;
                    at(i, e1), this.eventsEE = (0, Me.u)(i, e1), this.eventsEE.on(gt, function(e1, t1) {
                        this.bstStart = (0, _.t)();
                    }), this.eventsEE.on(pt, function(e1, r) {
                        (0, S.p)("bst", [
                            e1[0],
                            r,
                            this.bstStart,
                            (0, _.t)()
                        ], void 0, t1.K7.sessionTrace, i);
                    }), i.on(mt + lt, function(e1) {
                        this.time = (0, _.t)(), this.startPath = location.pathname + location.hash;
                    }), i.on(mt + ft, function(e1) {
                        (0, S.p)("bstHist", [
                            location.pathname + location.hash,
                            this.startPath,
                            this.time
                        ], void 0, t1.K7.sessionTrace, i);
                    });
                    try {
                        s = new PerformanceObserver((e1)=>{
                            const r = e1.getEntries();
                            (0, S.p)(dt, [
                                r
                            ], void 0, t1.K7.sessionTrace, i);
                        }), s.observe({
                            type: ut,
                            buffered: !0
                        });
                    } catch (e1) {}
                    this.importAggregator(e1, ()=>r.e(478).then(r.bind(r, 6974)), {
                        resourceObserver: s
                    });
                }
            }
            var yt = r(733), bt = r(6344);
            class Et extends W {
                static featureName = bt.TZ;
                #i;
                recorder;
                constructor(e1){
                    var n;
                    let i;
                    super(e1, bt.TZ), n = e1, (0, N.Y)(k.CH, function() {
                        (0, S.p)(k.CH, [], void 0, t1.K7.sessionReplay, n.ee);
                    }, n), function(e1) {
                        (0, N.Y)(k.Tb, function() {
                            (0, S.p)(k.Tb, [], void 0, t1.K7.sessionReplay, e1.ee);
                        }, e1);
                    }(e1);
                    const s = "".concat(u.Wt).concat((0, yt.Y)(e1.info.licenseKey, e1.info.applicationID));
                    try {
                        i = JSON.parse(localStorage.getItem(s));
                    } catch (e1) {}
                    (0, I.SR)(e1.init) && this.ee.on(k.CH, ()=>this.#s()), this.#a(i) && this.importRecorder().then((e1)=>{
                        e1.startRecording(bt.Qb.PRELOAD, i?.sessionReplayMode);
                    }), this.abortHandler = this.#n, this.importAggregator(this.agentRef, ()=>r.e(478).then(r.bind(r, 6167)), this), this.ee.on("err", (e1)=>{
                        this.blocked || this.agentRef.runtime.isRecording && (this.errorNoticed = !0, (0, S.p)(bt.Vh, [
                            e1
                        ], void 0, this.featureName, this.ee));
                    });
                }
                #a(e1) {
                    return e1 && (e1.sessionReplayMode === u.g.FULL || e1.sessionReplayMode === u.g.ERROR) || (0, I.Aw)(this.agentRef.init);
                }
                importRecorder() {
                    return this.recorder ? Promise.resolve(this.recorder) : (this.#i ??= Promise.all([
                        r.e(478),
                        r.e(249)
                    ]).then(r.bind(r, 4866)).then(({ Recorder: e1 })=>(this.recorder = new e1(this), this.recorder)).catch((e1)=>{
                        throw this.ee.emit("internal-error", [
                            e1
                        ]), this.blocked = !0, e1;
                    }), this.#i);
                }
                #s() {
                    this.blocked || (this.featAggregate ? this.featAggregate.mode !== u.g.FULL && this.featAggregate.initializeRecording(u.g.FULL, !0, bt.Qb.API) : this.importRecorder().then(()=>{
                        this.recorder.startRecording(bt.Qb.API, u.g.FULL);
                    }));
                }
                #n() {
                    this.recorder?.stopRecording();
                }
            }
            var wt = r(3962);
            class Rt extends W {
                static featureName = wt.TZ;
                constructor(e1){
                    if (super(e1, wt.TZ), function(e1) {
                        const r = e1.ee.get("tracer");
                        function n() {}
                        (0, N.Y)(k.dT, function(e1) {
                            return (new n).get("object" == typeof e1 ? e1 : {});
                        }, e1);
                        const i = n.prototype = {
                            createTracer: function(n, i) {
                                var s = {}, a = this, o = "function" == typeof i;
                                return (0, S.p)(q.xV, [
                                    "API/createTracer/called"
                                ], void 0, t1.K7.metrics, e1.ee), function() {
                                    if (r.emit((o ? "" : "no-") + "fn-start", [
                                        (0, _.t)(),
                                        a,
                                        o
                                    ], s), o) try {
                                        return i.apply(this, arguments);
                                    } catch (e1) {
                                        const t1 = "string" == typeof e1 ? new Error(e1) : e1;
                                        throw r.emit("fn-err", [
                                            arguments,
                                            this,
                                            t1
                                        ], s), t1;
                                    } finally{
                                        r.emit("fn-end", [
                                            (0, _.t)()
                                        ], s);
                                    }
                                };
                            }
                        };
                        [
                            "actionText",
                            "setName",
                            "setAttribute",
                            "save",
                            "ignore",
                            "onEnd",
                            "getContext",
                            "end",
                            "get"
                        ].forEach((r)=>{
                            N.Y.apply(this, [
                                r,
                                function() {
                                    return (0, S.p)(k.hw + r, [
                                        performance.now(),
                                        ...arguments
                                    ], this, t1.K7.softNav, e1.ee), this;
                                },
                                e1,
                                i
                            ]);
                        }), (0, N.Y)(k.PA, function() {
                            (0, S.p)(k.hw + "routeName", [
                                performance.now(),
                                ...arguments
                            ], void 0, t1.K7.softNav, e1.ee);
                        }, e1);
                    }(e1), !g.RI || !(0, i.dV)().o.MO) return;
                    const n = at(this.ee, e1);
                    try {
                        this.removeOnAbort = new AbortController;
                    } catch (e1) {}
                    wt.tC.forEach((e1)=>{
                        (0, J.sp)(e1, (e1)=>{
                            c(e1);
                        }, !0, this.removeOnAbort?.signal);
                    });
                    const s = ()=>(0, S.p)("newURL", [
                            (0, _.t)(),
                            "" + window.location
                        ], void 0, this.featureName, this.ee);
                    n.on("pushState-end", s), n.on("replaceState-end", s), (0, J.sp)(wt.OV, (e1)=>{
                        c(e1), (0, S.p)("newURL", [
                            e1.timeStamp,
                            "" + window.location
                        ], void 0, this.featureName, this.ee);
                    }, !0, this.removeOnAbort?.signal);
                    let a = !1;
                    const o = new ((0, i.dV)()).o.MO((e1, t1)=>{
                        a || (a = !0, requestAnimationFrame(()=>{
                            (0, S.p)("newDom", [
                                (0, _.t)()
                            ], void 0, this.featureName, this.ee), a = !1;
                        }));
                    }), c = (0, C.s)((e1)=>{
                        "loading" !== document.readyState && ((0, S.p)("newUIEvent", [
                            e1
                        ], void 0, this.featureName, this.ee), o.observe(document.body, {
                            attributes: !0,
                            childList: !0,
                            subtree: !0,
                            characterData: !0
                        }));
                    }, 100, {
                        leading: !0
                    });
                    this.abortHandler = function() {
                        this.removeOnAbort?.abort(), o.disconnect(), this.abortHandler = void 0;
                    }, this.importAggregator(e1, ()=>r.e(478).then(r.bind(r, 4393)), {
                        domObserver: o
                    });
                }
            }
            var Tt = r(981);
            const At = {}, St = new Set;
            function xt(e1) {
                return "string" == typeof e1 ? {
                    type: "string",
                    size: (new TextEncoder).encode(e1).length
                } : e1 instanceof ArrayBuffer ? {
                    type: "ArrayBuffer",
                    size: e1.byteLength
                } : e1 instanceof Blob ? {
                    type: "Blob",
                    size: e1.size
                } : e1 instanceof DataView ? {
                    type: "DataView",
                    size: e1.byteLength
                } : ArrayBuffer.isView(e1) ? {
                    type: "TypedArray",
                    size: e1.byteLength
                } : {
                    type: "unknown",
                    size: 0
                };
            }
            class Ot {
                constructor(e1, t1){
                    this.timestamp = (0, _.t)(), this.currentUrl = (0, Ee.L)(window.location.href), this.socketId = (0, ye.LA)(8), this.requestedUrl = (0, Ee.L)(e1), this.requestedProtocols = Array.isArray(t1) ? t1.join(",") : t1 || "", this.openedAt = void 0, this.protocol = void 0, this.extensions = void 0, this.binaryType = void 0, this.messageOrigin = void 0, this.messageCount = 0, this.messageBytes = 0, this.messageBytesMin = 0, this.messageBytesMax = 0, this.messageTypes = void 0, this.sendCount = 0, this.sendBytes = 0, this.sendBytesMin = 0, this.sendBytesMax = 0, this.sendTypes = void 0, this.closedAt = void 0, this.closeCode = void 0, this.closeReason = "unknown", this.closeWasClean = void 0, this.connectedDuration = 0, this.hasErrors = void 0;
                }
            }
            class _t extends W {
                static featureName = o.TZ;
                constructor(e1){
                    super(e1, o.TZ);
                    const n = e1.init.feature_flags.includes("websockets") || e1.init.web_sockets?.enabled, s = !e1.init.feature_flags.includes("no_spv"), a = [
                        e1.init.page_action.enabled,
                        e1.init.performance.capture_marks,
                        e1.init.performance.capture_measures,
                        e1.init.performance.resources.enabled,
                        e1.init.user_actions.enabled,
                        n,
                        s
                    ];
                    var c;
                    let d;
                    if (c = e1, (0, N.Y)(k.hG, (e1, t1)=>ce(e1, t1, c), c), function(e1) {
                        (0, N.Y)(k.fF, (t1, r)=>ue(t1, r, e1), e1);
                    }(e1), ct(e1), Se(e1), function(e1) {
                        (0, N.Y)(k.V1, (t1, r)=>de(t1, r, e1), e1);
                    }(e1), this.removeOnAbort = new AbortController, this.abortHandler = ()=>{
                        this.removeOnAbort.abort(), this.abortHandler = void 0;
                    }, n) {
                        const u = function(e1, t1) {
                            if (!(0, i.dV)().o.WS) return e1;
                            const r = e1.get("websockets");
                            if (At[r.debugId]++) return r;
                            At[r.debugId] = 1, (0, V.G)(()=>{
                                const e1 = (0, _.t)();
                                St.forEach((t1)=>{
                                    t1.nrData.closedAt = e1, t1.nrData.closeCode = 1001, t1.nrData.closeReason = "Page navigating away", t1.nrData.closeWasClean = !1, t1.nrData.openedAt && (t1.nrData.connectedDuration = e1 - t1.nrData.openedAt), r.emit("ws", [
                                        t1.nrData,
                                        t1.targets
                                    ], t1);
                                });
                            });
                            class n extends WebSocket {
                                static name = Tt.R.WS;
                                static toString() {
                                    return "function WebSocket() { [native code] }";
                                }
                                toString() {
                                    return "[object WebSocket]";
                                }
                                get [Symbol.toStringTag]() {
                                    return n.name;
                                }
                                #o(e1) {
                                    (e1.__newrelic ??= {}).socketId = this.nrData.socketId, this.nrData.hasErrors ??= !0;
                                }
                                constructor(...e1){
                                    super(...e1), this.nrData = new Ot(e1[0], e1[1]), this.targets = (0, Ie.$5)(t1), this.addEventListener("open", ()=>{
                                        this.nrData.openedAt = (0, _.t)(), [
                                            "protocol",
                                            "extensions",
                                            "binaryType"
                                        ].forEach((e1)=>{
                                            this.nrData[e1] = this[e1];
                                        }), St.add(this);
                                    }), this.addEventListener("message", (e1)=>{
                                        const { type: t1, size: r } = xt(e1.data);
                                        this.nrData.messageOrigin ??= (0, Ee.L)(e1.origin), this.nrData.messageCount++, this.nrData.messageBytes += r, this.nrData.messageBytesMin = Math.min(this.nrData.messageBytesMin || 1 / 0, r), this.nrData.messageBytesMax = Math.max(this.nrData.messageBytesMax, r), (this.nrData.messageTypes ?? "").includes(t1) || (this.nrData.messageTypes = this.nrData.messageTypes ? "".concat(this.nrData.messageTypes, ",").concat(t1) : t1);
                                    }), this.addEventListener("close", (e1)=>{
                                        this.nrData.closedAt = (0, _.t)(), this.nrData.closeCode = e1.code, e1.reason && (this.nrData.closeReason = e1.reason), this.nrData.closeWasClean = e1.wasClean, this.nrData.connectedDuration = this.nrData.closedAt - this.nrData.openedAt, St.delete(this), r.emit("ws", [
                                            this.nrData,
                                            this.targets
                                        ], this);
                                    });
                                }
                                addEventListener(e1, t1, ...r) {
                                    const n = this, i = "function" == typeof t1 ? function(...e1) {
                                        try {
                                            return t1.apply(this, e1);
                                        } catch (e1) {
                                            throw n.#o(e1), e1;
                                        }
                                    } : t1?.handleEvent ? {
                                        handleEvent: function(...e1) {
                                            try {
                                                return t1.handleEvent.apply(t1, e1);
                                            } catch (e1) {
                                                throw n.#o(e1), e1;
                                            }
                                        }
                                    } : t1;
                                    return super.addEventListener(e1, i, ...r);
                                }
                                send(e1) {
                                    if (this.readyState === WebSocket.OPEN) {
                                        const { type: t1, size: r } = xt(e1);
                                        this.nrData.sendCount++, this.nrData.sendBytes += r, this.nrData.sendBytesMin = Math.min(this.nrData.sendBytesMin || 1 / 0, r), this.nrData.sendBytesMax = Math.max(this.nrData.sendBytesMax, r), (this.nrData.sendTypes ?? "").includes(t1) || (this.nrData.sendTypes = this.nrData.sendTypes ? "".concat(this.nrData.sendTypes, ",").concat(t1) : t1);
                                    }
                                    try {
                                        return super.send(e1);
                                    } catch (e1) {
                                        throw this.#o(e1), e1;
                                    }
                                }
                                close(...e1) {
                                    try {
                                        super.close(...e1);
                                    } catch (e1) {
                                        throw this.#o(e1), e1;
                                    }
                                }
                            }
                            return g.gm.WebSocket = n, r;
                        }(this.ee, e1);
                        u.on("ws", (e1, t1)=>{
                            (0, S.p)("ws-complete", [
                                e1,
                                t1
                            ], void 0, this.featureName, this.ee);
                        });
                    }
                    if (s) {
                        if ("function" == typeof g.gm.ReportingObserver) {
                            const l = new g.gm.ReportingObserver((e1)=>{
                                e1.forEach((e1)=>{
                                    (0, S.p)("spv", [
                                        kt(e1),
                                        (0, _.t)()
                                    ], void 0, t1.K7.genericEvents, this.ee);
                                }), l.disconnect();
                            }, {
                                types: [
                                    "csp-violation"
                                ],
                                buffered: !0
                            });
                            l.observe();
                        }
                        g.gm.addEventListener("securitypolicyviolation", (e1)=>{
                            (0, S.p)("spv", [
                                kt(e1),
                                e1.timeStamp
                            ], void 0, t1.K7.genericEvents, this.ee);
                        }, (0, J.jT)(!1, this.removeOnAbort.signal));
                    }
                    if (g.RI) {
                        if (ze(this.ee, e1), De(this.ee, e1), d = at(this.ee, e1), e1.init.user_actions.enabled) {
                            function f(t1) {
                                const r = (0, Ge.D)(t1);
                                return e1.beacons.includes(r.hostname + ":" + r.port);
                            }
                            function h() {
                                d.emit("navChange");
                            }
                            o.Zp.forEach((e1)=>(0, J.sp)(e1, (e1)=>(0, S.p)("ua", [
                                        e1
                                    ], void 0, this.featureName, this.ee), !0)), o.qN.forEach((e1)=>{
                                const t1 = (0, C.s)((e1)=>{
                                    (0, S.p)("ua", [
                                        e1
                                    ], void 0, this.featureName, this.ee);
                                }, 500, {
                                    leading: !0
                                });
                                (0, J.sp)(e1, t1);
                            }), g.gm.addEventListener("error", ()=>{
                                (0, S.p)("uaErr", [], void 0, t1.K7.genericEvents, this.ee);
                            }, (0, J.jT)(!1, this.removeOnAbort.signal)), this.ee.on("open-xhr-start", (e1, r)=>{
                                f(e1[1]) || r.addEventListener("readystatechange", ()=>{
                                    2 === r.readyState && (0, S.p)("uaXhr", [], void 0, t1.K7.genericEvents, this.ee);
                                }, (0, J.jT)(void 0, this.removeOnAbort.signal));
                            }), this.ee.on("fetch-start", (e1)=>{
                                e1.length >= 1 && !f(Ze(e1[0])) && (0, S.p)("uaXhr", [], void 0, t1.K7.genericEvents, this.ee);
                            }), d.on("pushState-end", h), d.on("replaceState-end", h), window.addEventListener("hashchange", h, (0, J.jT)(!0, this.removeOnAbort.signal)), window.addEventListener("popstate", h, (0, J.jT)(!0, this.removeOnAbort.signal));
                        }
                        if (e1.init.performance.resources.enabled && g.gm.PerformanceObserver?.supportedEntryTypes.includes("resource")) new PerformanceObserver((e1)=>{
                            e1.getEntries().forEach((e1)=>{
                                (0, S.p)("browserPerformance.resource", [
                                    e1
                                ], void 0, this.featureName, this.ee);
                            });
                        }).observe({
                            type: "resource",
                            buffered: !0
                        });
                    }
                    a.some((e1)=>e1) ? this.importAggregator(e1, ()=>r.e(478).then(r.bind(r, 8019))) : this.deregisterDrain();
                }
            }
            function kt(e1) {
                const t1 = e1.body ?? e1;
                return {
                    blockedUrl: t1.blockedURL ?? e1.blockedURI,
                    documentUrl: t1.documentURL ?? e1.documentURI,
                    effectiveDirective: t1.effectiveDirective,
                    originalPolicy: t1.originalPolicy,
                    sourceFile: t1.sourceFile,
                    statusCode: t1.statusCode,
                    lineNumber: t1.lineNumber,
                    columnNumber: t1.columnNumber,
                    disposition: "reporting" === t1.disposition ? "report" : t1.disposition,
                    sample: t1.sample,
                    referrer: t1.referrer
                };
            }
            var Nt = r(2646);
            const Lt = new Map;
            function Mt(e1, t1, r, n, i = !0, s) {
                if ("object" != typeof t1 || !t1 || "string" != typeof r || !r || "function" != typeof t1[r]) return (0, l.R)(29);
                const a = function(e1) {
                    return (e1 || R.ee).get("logger");
                }(e1), o = (0, Pe.YM)(a, void 0, s), c = new Nt.y(R.P);
                c.level = n.level, c.customAttributes = n.customAttributes, c.autoCaptured = i;
                const d = t1[r]?.[Pe.Jt] || t1[r];
                return Lt.set(d, c), o.inPlace(t1, [
                    r
                ], "wrap-logger-", ()=>Lt.get(d), void 0, !0), a;
            }
            var Pt = r(1910);
            class It extends W {
                static featureName = se.TZ;
                constructor(e1){
                    var t1;
                    super(e1, se.TZ), t1 = e1, (0, N.Y)("log", (e1, r)=>oe(e1, r, t1), t1), function(e1) {
                        (0, N.Y)(k.Wb, (t1, r, { customAttributes: n = {}, level: i = se.p_.INFO } = {})=>{
                            Mt(e1.ee, t1, r, {
                                customAttributes: n,
                                level: i
                            }, !1, e1);
                        }, e1);
                    }(e1), Se(e1);
                    const n = this.ee;
                    [
                        "log",
                        "error",
                        "warn",
                        "info",
                        "debug",
                        "trace"
                    ].forEach((t1)=>{
                        (0, Pt.i)(g.gm.console[t1]), Mt(n, g.gm.console, t1, {
                            level: "log" === t1 ? "info" : t1
                        }, void 0, e1);
                    }), this.ee.on("wrap-logger-end", function([t1], r, i, s = [
                        e1.runtime.v2Target
                    ]) {
                        const { level: a, customAttributes: o, autoCaptured: c } = this;
                        s.forEach((e1)=>{
                            (0, ae.R)(n, t1, o, a, c, e1);
                        });
                    }), this.importAggregator(e1, ()=>r.e(478).then(r.bind(r, 5288)));
                }
            }
            new F({
                features: [
                    nt,
                    K,
                    G,
                    vt,
                    Et,
                    Y,
                    Oe,
                    _t,
                    It,
                    Rt
                ],
                loaderType: "spa"
            });
        })();
    })();
};

//# sourceMappingURL=member-portal-elm.1353ee45.js.map
